<template>
  <div
    class="TopNav"
    :style="{
      width: TopNav_Size.width + 'px',
      height: TopNav_Size.height + 'px',
    }"
  >
    <section class="left-logo">
      <el-tooltip
        effect="dark"
        content="快捷菜单"
        placement="bottom"
        :open-delay="1000"
      >
        <div class="menu">
          <i class="menu-icon" @click="showQuickManu"></i>
        </div>
      </el-tooltip>
      <!-- <a target="_blank" href="/templates">
        <img src="../../static/svg/laipic-logo-dark.png" alt="logo" />
      </a> -->
      <AppLogo></AppLogo>
    </section>
    <section class="center-title">
      <div class="left-grid">
        <!-- v-show="isNameEditable" -->
        <span class="works-title-input">
          <input
            v-model="myWorksName"
            type="text"
            @focus="
              togglePreventDefault(false);
              myWorksNameOld = myWorksName;
            "
            @blur="
              changeWorksName();
              togglePreventDefault(true);
            "
            @keydown.enter="onTitleInputEnter($event)"
            ref="worksNameRef"
            maxlength="32"
          />
        </span>
        <!-- <span
          class="works-title"
          v-show="!isNameEditable"
          @dblclick="setEditable()"
          @mouseenter="toggleHover(true)"
          @mouseleave="toggleHover(false)"
        >
          <span>{{myWorksName}}</span>
          <i
            class="icon-title-edit"
            v-if="isComponentHover"
            :style="{cursor: 'pointer'}"
            @click="setEditable()"
          ></i>
        </span>-->
        <!-- <el-tooltip effect="dark" content="保存至'我的项目'" placement="bottom" :open-delay="1000">
          <div
            class="svae-grid"
            ref="btnSave"
            @click="saveWorks"
            v-loading="saveState === 'saving'"
            element-loading-background="white"
            v-analysis="ANALYSIS.save"
          >
            <div save-logo>
              <div class="save-img"></div>
              <span>保存</span>
            </div>
            <span class="save-time" v-show="saveDraftTime">{{saveDraftTime}}已保存</span>
          </div>
        </el-tooltip>-->
      </div>

      <div class="right-grid">
        <div class="history-switcher-wrapper">
          <historySwitcher @clickItem="openHistoryControl"></historySwitcher>
        </div>
        <template v-if="!isCoworker()">
          <!-- @mouseenter="editorLoadMore" -->
          <div
            class="copyrightRisk"
            @mouseenter="onRiskHover"
            @mouseleave="onRiskMouseLeave"
            style="height: 36px"
          >
            <div class="bg layout" v-if="UserLevelInfo.trial">
              <div class="icon"></div>
              <span>不可商用</span>
            </div>
            <div class="bg layout no-risk" v-else-if="!isRisk() && UserLevelInfo.levelName === 'standard'">
              <div class="icon"></div>
                <span class="no-risk-text">会员商用</span>
            </div>
            <div class="bg layout" v-else-if="isRisk() || UserLevelInfo.levelCode <= 1">
              <div class="icon"></div>
              <!-- <span style="color: #ea3d45">{{ getCartItemsNum() }}</span> -->
              <!-- <span>个版权及权益风险</span> -->
              <!-- <span>版权或使用权益提示</span> -->
              <span v-if="isRightsRisk()">付费提示</span>
              <span v-else>商用提示</span>
            </div>
            <div class="bg layout no-risk" v-else>
              <template v-if="isPoor">
                <div class="icon person-learn"></div>
                <span class="person-learn-text">仅个人学习交流使用</span>
              </template>
              <template v-else>
                <div class="icon"></div>
                <!-- <span class="no-risk-text">无版权及权益风险</span> -->
                <span class="no-risk-text">会员商用</span>
              </template>
              <!-- <span>{{isPoor ? '仅个人学习交流使用' : '无版权及权益风险'}}</span> -->
            </div>

            <!-- :style="riskVisible ? {display: 'block'} : {}" -->
            <div
              v-show="riskDropVisible"
              class="copyrightRisk-drop"
              style="display: block"
            >
              <RiskDrop
                ref="riskDropRef"
                type="authority"
                @mouseOver="riskDropMouseOver"
              ></RiskDrop>
            </div>
          </div>

          <div class="copyrightRiskOK" v-if="false">
            <div class="bg layout">
              <div class="icon"></div>
              <span>{{
                isPoor ? "仅个人学习交流使用" : "无版权及权益风险"
              }}</span>
            </div>
            <div class="copyrightOK-drop">
              <span>
                当前设计无版权风险，免费用户仅可用于个人学习交流使用，
                <span>会员用户</span>商业使用范围需符合当前会员类型。
              </span>
            </div>
          </div>
        </template>

        <div
          class="vipUpgrade"
          @mouseenter.stop="toggleVipDropStatus(true)"
          @mouseleave.stop="toggleVipDropStatus(false)"
          v-if="UserLevel == 0 || 0 <= TmpLevelType"
        >
          <div class="bg layout">
            <div class="icon"></div>
            <span>会员升级</span>
          </div>

          <div class="vip-drop" v-show="vipDropStatus">
            <VipDrop></VipDrop>
          </div>
        </div>
        <div class="back-new" @click="onVersionSwitch">
          <div class="version-switch-logo">
            <img src="/static/img/versionSwitch/versionNew.png" alt="" />
          </div>
          <div class="version-switch-logo-hover">
            <img src="/static/img/versionSwitch/versionNew01.png" alt="" />
          </div>
        </div>
        <!-- <div class="cooperation" v-if="showCooperationBtn">
          <div class="bg layout" @click="clickCooperation">
            <div class="icon"></div> -->
            <!-- <span>协作</span> -->
          <!-- </div> -->
          <!-- 添加协作成员弹框 -->
          <!-- <add-cooperation-dialog
            :if="dialogVisible"
            v-model="dialogVisible"
            :current-page="1"
            :privateDraft="privateDraft"
            :current-draft="currentDraft"
            :loadType="loadType"
            type="mydraft"
            @close-dialog="closeCooperationDialog"
          ></add-cooperation-dialog>
        </div> -->

        <!-- <div
          class="addSubtitle"
          @click="openSubtitleLayer"
        >
          <div class="bg layout">
            <div class="icon"></div>
            <span>添加字幕</span>
          </div>
        </div> -->

        <!-- <div @click="openSubtitleLayer">添加字幕</div> -->
        <!-- <div
          class="versionHistory"
          @click="openVersionControl"
          v-if="currentDraft && currentDraft.cooperationType >= 0 && !privateDraft"
        >
          <div class="bg layout">
            <div class="icon"></div>
            <span>版本记录</span>
          </div>
        </div>-->

        <div
          class="save"
          @click="
            checkTrialExpire();
            manualSave = 'click';
            saveWorks();
          "
        >
          <div class="bg layout">
            <div
              class="icon"
              id="save-btn-icon"
              v-analysis="ANALYSIS.save"
            ></div>
            <span v-show="saveState !== 'saving'" style="color: #5778fb">
              {{ saveState === "saved" ? saveDraftTime + "已保存" : "保存" }}
            </span>
            <span v-show="saveState === 'saving'" style="color: #5778fb">
              {{ saveDraftTime + "保存中" }}
            </span>
          </div>
        </div>

        <el-tooltip
          effect="dark"
          content="PPT演示模式"
          placement="bottom"
          :open-delay="1000"
          :disabled="presentationTipMousing"
        >
          <div class="presentation-btn" @click="showPresentation">
            <div class="badge"></div>
            <i class="iconfont iconpptyanshi" style="font-size: 22px"></i>
            <div
              v-if="presentationTipShown"
              class="presentation-tip-wrapper"
              @mouseenter="presentationTipMousing = true"
              @mouseleave.stop="presentationTipMousing = false"
              @click.stop
            >
              <presentationTip v-model="presentationTipShown"></presentationTip>
            </div>
          </div>
        </el-tooltip>

        <el-tooltip
          effect="dark"
          content="预览整个视频"
          placement="bottom"
          :open-delay="1000"
        >
          <div
            v-if="!isShowCompleteBtn"
            class="play-btn button--primary"
            :data-loadingScenes="isShowScenesLoading"
            @click="playWhole"
            v-analysis="ANALYSIS.gPreview"
          >
            <!-- 预览 -->
            <i class="iconfont icondongtaibeijing-bofang1"></i>
          </div>
        </el-tooltip>

        <!-- <el-tooltip
          slot="reference"
          effect="dark"
          content="导出后可分享或下载"
          placement="bottom"
          :open-delay="1000"
          :disabled="
            this.UserMsg && (this.UserMsg.type == 2 || this.UserMsg.type == 3)
          "
        >
          <div
            class="export-btn button--primary customerServiceCil"
            :style="{ width: '80px' }"
            @click.stop="
              handleAdvancedUser();
              showExportDialog();
            "
            ref="exportBtnRef"
            v-if="!userType && UserTeamInfo == null"
          >
            导出
            <div v-if="trialExpireRiskShown" class="expire-risk-wrapper">
              <trialExpireRisk v-model="trialExpireRiskShown"></trialExpireRisk>
            </div>
          </div>
        </el-tooltip> -->

        <!-- <el-button
          v-if="isShowReview"
          class="reviewdraft-btn"
          type="primary"
          :disabled="isDisabled"
          @click.stop="commitReviewDraft()"
          >提交审核</el-button
        > -->

        <el-tooltip
          effect="dark"
          content="预览整个视频"
          placement="bottom"
          :open-delay="1000"
        >
          <div
            v-if="isShowCompleteBtn"
            class="play-btn button--primary"
            :data-loadingScenes="isShowScenesLoading"
            @click="playWhole"
            v-analysis="ANALYSIS.gPreview"
          >
            <!-- 预览 -->
            <i class="iconfont icondongtaibeijing-bofang1"></i>
          </div>
        </el-tooltip>

        <!-- <div
          class="reviewdraft-btn"
          @click="commitReviewDraft"

        >
          <span>提交审核</span>
        </div> -->

        <!-- && !(reviewDraft && (isPassDraft !== 6 || (isPassDraft === 6 && changeOriginalDraft))) -->
        <!-- v-if="isShowExport" -->
        <div
          v-show="isShowCompleteBtn"
          class="export-btn button--primary customerServiceCil"
          ref="exportBtnRef"
        >
          <span class="btn-name"
            >完成<i class="btn-icon"><i class="tri"></i></i
          ></span>
          <div class="export-drop">
            <div class="export-list">
              <div
                @click.stop="
                  handleAdvancedUser();
                  exportVideo();
                "
              >
                <span>导出MP4</span>
                <span class="template-game-badge ghost" v-if="templateGame"
                  >活动中</span
                >
              </div>

              <div
                @click.stop="
                  $modal.show('presentationLink', { source: '生成PPT演示链接' })
                "
                class="create-presentation-link"
              >
                <span>生成PPT链接</span>
                <div class="badge"></div>
              </div>

              <div
                v-if="
                  judgeUpdataTemplate == 'template' &&
                  UserTeamInfo &&
                  UserTeamInfo.state !== 5 && TeamInfo && [0].includes(TeamInfo.state)
                "
                @click="publishTeamTemplate()"
              >
                <span>设为团队模板</span>
                <span class="template-game-badge ghost" v-if="templateGame"
                  >活动中</span
                >
              </div>

              <div
                v-if="judgeUpdataTemplate == 'template' && UserMsg && userType"
                @click="painterFS('template')"
              >
                <span>WEB模板</span>
                <span class="template-game-badge ghost" v-if="templateGame"
                  >活动中</span
                >
              </div>

              <div
                v-if="judgeUpdataTemplate == 'template' && UserMsg && userType"
                @click="painterAppFS('template')"
              >
                <span>APP模板</span>
                <span class="template-game-badge ghost" v-if="templateGame"
                  >活动中</span
                >
              </div>

              <div
                v-if="
                  judgeUpdataTemplate == 'updataTemplate' && UserMsg && userType
                "
                @click="updataTemplateFS()"
              >
                <span>更新模板</span>
                <span class="template-game-badge ghost" v-if="templateGame"
                  >活动中</span
                >
              </div>
              <div
                v-if="scenesCombination && UserMsg && userType"
                @click="painterFS('combination')"
              >
                <span>组合素材</span>
                <span class="template-game-badge ghost" v-if="templateGame"
                  >活动中</span
                >
              </div>

              <div
                v-if="scenesCombination && UserMsg && userType"
                @click="showListDialog()"
              >
                <span>场景素材</span>
                <span class="template-game-badge ghost" v-if="templateGame"
                  >活动中</span
                >
              </div>
            </div>
          </div>
          <div v-if="trialExpireRiskShown" class="expire-risk-wrapper">
            <trialExpireRisk v-model="trialExpireRiskShown"></trialExpireRisk>
          </div>
        </div>
      </div>
    </section>
    <div
      class="riskDrop"
      style="position: absolute; top: 100%; right: 12px"
      v-show="riskVisible"
    >
      <qr
        style="position: absolute; top: 5px; right: calc(5px + 100%)"
        :text="['扫码领取会员', '领创作素材包']"
        :id="'1514100029051248640'"
      ></qr>
      <RiskDrop
        ref="riskDropRef2"
        @close="riskVisible = false"
        type="export"
      ></RiskDrop>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="isExamineDialogVisible"
      width="464px"
      :modal="false"
      center
    >
      <div>
        提交审核将会把草稿转为协作草稿，你可以在,
        <a href="/workplace/dashboard/team/cooperation" target="_blank">团队-协作草稿</a
        >中找到它。是否提交审核？
      </div>
      <div class="check">
        <el-checkbox v-model="checkboxValue"></el-checkbox>
        <span>之后不再提示</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isExamineDialogVisible = false">再想想</el-button>
        <el-button type="primary" @click="confirmSend()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import langSelect from "./langSelect";
import { mapGetters, mapActions, mapMutations } from "vuex";
import domtoimage from "@/plugins/dom-to-image";
import setBlobImageSize from "@/plugins/setBlobImageSize";
import snap from "./mixins/snap";
import Analysis from "./mixins/analysis/materialBu";
import checkPersonVideo from "./mixins/checkPersonVideo";
import judgevipComponents from "./mixins/judgeVip/judgeVipEvent.vue"; // 会员判断函数
import VipDrop from "./topnav/vipDrop.vue";
import CopyrightRiskDrop from "./topnav/copyrightRiskDrop.vue";
import RiskDrop from "./topnav/riskDrop.vue";
import addCooperationDialog from "../components/emodal/add-cooperation-dialog.vue";
import draft from "./mixins/draft";
import historySwitcher from "./topnav/historySwitcher.vue";
import Cookies from "js-cookie";
import durationLimitMixin from "./tool/timeline/limitMixin.vue";
import { getVipList as getVipSceneEffects } from "./topnav/riskDrop/sceneEffectTypes.js";
import qr from './widgets/qr.vue';
import trialExpireRisk from './topnav/trialExpireRisk.vue';
import presentationTip from './topnav/presentationTip.vue';
import AppLogo from './topnav/appLogo.vue'

let isBlank = false;

(function () {
  let hash = window.location.hash || "";
  isBlank = hash.slice(2).length !== 36;
})();

export default {
  mixins: [
    snap,
    draft,
    Analysis,
    checkPersonVideo,
    judgevipComponents,
    durationLimitMixin,
  ],
  data() {
    let templateId = this.$route.template;
    if (!templateId || (templateId && templateId.length < 18)) {
      templateId = "";
    }
    return {
      checkboxValue: true,
      isExamineDialogVisible: false,
      vipDropStatus: false,
      ANALYSIS: {
        help: {
          category: "editor_gridlines",
          action: "click_help",
          label: "编辑器_教程使用",
        },
        save: {
          category: "editor_others",
          action: "click_save",
          label: "编辑器其他_保存",
        },
        gPreview: {
          category: "editor_others",
          action: "click_global_preview",
          label: "编辑器其他_全局预览",
        },
        customerService: {
          category: "editor_navigator",
          action: "click_custom_service",
          label: "编辑器_客服",
        },
        shopping: {
          category: "editor_shopping",
          action: "click_online_shop",
          label: "编辑器_商城",
        },
      },
      activateShortcuts: false,
      saved: false,
      // myWorksName: "",
      myWorksNameOld: "",
      isNameEditable: false,
      isComponentHover: false,
      snaps: [],
      snapArr: ["", "", ""],
      cacheScene: null,
      msgInstance: null,
      isLock: false,
      worksJson: null,
      // saveState: "notSaved", // notSaved | saving | saved
      btnSave: {
        notSaved: {
          text: "保存",
        },
        saving: {
          text: "保存",
        },
        saved: {
          text: "已保存",
          style: {
            opacity: 0.35,
          },
        },
      },
      saveLoadingComp: null,
      tid: null,
      coverParam: "", // 对应项目接口的thumbnailUrl
      screenParam: "", // 对应项目接口的screen
      promiseGetSnaps: null,
      isShowPopover: false,
      isDraftExist: false,
      loadType: "",
      // checkedOnOpenPage: false,
      templateid: templateId, // id in url params
      newVersion: false, // 判断元素是否点击过更新版本按钮
      judgeUpdataTemplate: "template",
      updataTemplatedata: {},
      userType: false,
      scenesCombination: false,
      templateGame: false,
      saveDraftTime: "",
      dialogVisible: false, //协作弹窗
      currentDraft: null,
      draftId: "", //项目Id,保存项目时和projectId一起返回的
      draftOwnerId: "",
      privateDraft: null,
      saveDraftInterval: 60000,
      backupTimer: null,
      reviewDraft: 0,
      isPassDraft: 0,
      changeOriginalDraft: false,
      riskVisible: false,
      riskDropVisible: false,
      QRVisible: false,
      isUserVersion: false,
      saveWorksValue: false,
      isDisabled: false,
      trialExpireRiskShown: false,
      presentationTipShown: false,
      presentationTipMousing: false,
      useIpLists: []
    };
  },
  computed: {
    ...mapGetters([
      "UserLevelName",
      "MaterialPane_Size",
      "TopNav_Size",
      "TOOL",
      "Tool_Size",
      "WorksName",
      "WorksId",
      "WorksProjectId",
      "isPreventDefault",
      "SelectSprites_Msg",
      "SelectScenes_Msg",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "TmpLevelType",
      "UserMsg",
      "IsVipSprites",
      "WatermarkInfo",
      "StyleArrayMsg",
      "cooperationType",
      "UserTeamInfo",
      "TeamInfo",
      "showCooperationBtn",
      "cooperationDraftOwnerId",
      "IsPrivateDraft",
      "joinCooDraftStateInfo",
      "cooperationDraftId",
      "WorksSaveState",
      "WorksName",
      "isPoor",
      "UserLevelInfo",
      "CommercialRisk",
      "isEenterprise"
    ]),
    ...mapGetters({
      storedUserId: "getUserId",
      duringBackup: "draftBackup/getDuringBackup",
      backupIntervalMinutes: "draftBackup/getIntervalMinutes",
      backupState: "draftBackup/getBackupState",
      saveState: "WorksSaveState",
      subtitleEditor: "subtitle/subtitleEditor",
      subtitleObj: "subtitle/subtitleObj",
      componyvipMaterial: "resources/componyvipMaterial",
      isShowScenesLoading: 'materialArea/isShowScenesLoading'
    }),
    isShowReview() {
      const isTeamValid = (this.TeamInfo || {}).state === 0;
      if (!isTeamValid) {
        return false;
      }
      return (this.privateDraft ||
        (!this.privateDraft &&
          this.currentDraft &&
          this.currentDraft.userId === this.UserMsg.id)) &&
        ((this.UserTeamInfo != null && this.reviewDraft === 0) || this.reviewDraft) &&
        this.UserTeamInfo &&
        this.UserTeamInfo.state !== 5 &&
        (this.isPassDraft !== 6 || (this.isPassDraft === 6 && this.changeOriginalDraft));
    },
    isShowCompleteBtn () {
      if (this.isShowReview && this.reviewDraft) return false;
      return true;
    },
    isShowVersionSwitch() {
      // console.log('this.currentDraft==>', this.currentDraft, this.privateDraft);
      return this.privateDraft || (this.currentDraft && this.currentDraft.userId === this.UserMsg.id);
    },
    isShowExport() {
      let r = (this.userType || this.UserTeamInfo != null) &&
        !(
          (this.privateDraft ||
            (!this.privateDraft &&
              this.currentDraft &&
              this.currentDraft.userId === this.UserMsg.id)) && this.reviewDraft && (
            this.isPassDraft !== 6 || (this.isPassDraft === 6 && this.changeOriginalDraft)
          )
        );
      if (this.isPassDraft === 6 && this.changeOriginalDraft) {
        r = false;
      }
      if (this.isPassDraft === 5) {
        r = false;
      }
      return r;
    },
    myWorksName: {
      get() {
        return this.WorksName;
      },
      set(val) {
        this.$store.commit("save_WorksName", val);
      },
    },
  },
  watch: {
    activateShortcuts(val) {
      // 是否启用快捷键
      this.$store.commit("toggle_isPreventDefault", val);
    },
    saveState: function (val, oldVal) {
      const vm = this;
      this.$store.commit("set_WorksSaveState", val);
      if (val === "saved") {
        window.onbeforeunload = null;
      } else {
        window.onbeforeunload = function (e) {
          (e || window.event).returnValue = "确定离开此页吗？";
        };
      }

      if (val === "notSaved") {
        this.$store.commit("draftBackup/setBackupState", "none");
      }
    },

    TOOL: async function (val) {
      //console.log("this.TOOL", val);
      if (this.TOOL) {
        //console.log("this.TOOL", this.TOOL, this.subtitleEditor);
        this.TOOL.subtitleEditor = this.subtitleEditor;
      }

      let loadType = this.loadType;
      if (loadType === "blank") {
        // this.$store.commit('save_WorksProjectId', this.getUuidInHash());
        // this.saveWorks_

        this.setLoadingStatus("success");
        this.setAllVideosReady();
        this.$bus.emit("updateAllScenes", this.TOOL.sprites);

        this.myWorksName = await this.getUntitle();
        this.$store.commit("save_WorksName", this.myWorksName);
        setTimeout(
          function () {
            this.intervalSaveWorks();
            // this.saveWorks()
          }.bind(this),
          2000
        );

        this.$bus.emit("hintMessage_vue", { data: false });
        this.addEmptyMsg();
        this.judgeVip_worksDraftNum();
      }

      // eve.once("editor.fromJsonDone", () => {
      this.$bus.on("updateAllScenes", async (scenes) => {
        this.$bus.emit("setTemplateStyle");
        this.listenVisibilitychange();
        this.intervalSaveWorks();
        // this.saveWorks_

        if (this.loadType !== "blank") {
          this.initBackup();
        }

        let videos =
          document.querySelectorAll("#app>.Tool video, #app>.Scenes video") ||
          [];
        videos = [].slice.call(videos, 0);
        if (!videos.length) {
          this.setAllVideosReady();
          return;
        }
        let pArr = videos.map((el) => {
          if (el.preload === "none") {
            el.preload = "auto";
            el.load();
          }
          return this.checkVideoLoad(el);
        });
        Promise.all(pArr)
          .then(() => {
            this.setAllVideosReady();
          })
          .catch(() => {
            this.setAllVideosReady();
          });

        // 从模板或故事板打开时，立马保存一次
        // if (loadType === 'template' || loadType === 'story') {
        //   this.saveWorks();
        // }

        // this.promiseGetSnaps && this.promiseGetSnaps
        // .then(() => {
        //   this.TOOL.selectScenes(this.TOOL.sprites[0]);
        // })
        // .catch(() => {
        //   this.TOOL.selectScenes(this.TOOL.sprites[0]);
        // })
      });

      setTimeout(
        function () {
          loadType === "story" && this.getStory();
        }.bind(this),
        2000
      );
    },
    myWorksName(val, old) {
      if (val !== old) {
        this.$store.commit("set_WorksSaveState", "notSaved");
      }
    },
    isDraftExist(val) {
      if (val) {
        this.$bus.emit("projectStyle", { type: true });
      }
    },
    "UserMsg.type": function (val, oldval) {
      const vm = this;
      // UserMsg.type: 0管理员  1普通用户 2外部画师 3来画画师  4.普通管理员(后台管理员中权限最低)
      //               5.合作方管理员，6.会员权限管理员(再普通会员基础上增加会员管理权限),
      //               7:发现广场管理员, 8:学院课程管理员,9:视频学院管理员,10:运营专员
      // 0，4，6可以更新任意模版，导出组合，场景
      switch (this.UserMsg.type) {
        case 0:
        case 2:
        case 3:
        case 4:
        case 6:
          this.userType = true;
          break;
      }
      switch (
      this.UserMsg.type // 组合，场景发布
      ) {
        case 0:
        case 3:
        case 4:
        case 6:
          this.scenesCombination = true;
          break;
      }
      if (this.$route.template) {
        switch (
        this.UserMsg.type // 组合，场景发布
        ) {
          case 0:
          case 3:
          case 4:
          case 6:
            this.updataTemplatedata = { id: this.$route.template };
            this.judgeUpdataTemplate = "updataTemplate";
            break;
        }
      }

      // if (this.UserMsg.type === 2) {
      //   vm.$http
      //     .get('/api/promotion/activities')
      //     .then(res => {
      //       let data = res.data.data || {};
      //       vm.templateGame = data.startActivties.some(v => v.type === 1);
      //     })
      //     .catch(err => console.warn(err));
      // }
    },
    dialogVisible(val) {
      if (val) {
      }
    },
    backupIntervalMinutes(val, oldVal) {
      if (val !== oldVal) {
        this.countdown();
      }
    },
    WorksId(val) {
      if (val && this.loadType === "blank") {
        // 备份
        this.initBackup();
      }
    },
    privateDraft(val, oldVal) {
      this.$store.commit("setPrivateDraft", val);
      if (!val && oldVal) {
        this.initBackup();
      }
    }
    // currentDraft: {
    //   handler (val) {
    //     console.log(`Turbo ~ handler ~ val`, val)
    //   },
    //   deep: true
    // }
  },
  async created() {
    if (this.$route.subtitle) return;
    // 初始化字幕
    // this.$store.commit("subtitle/setSubtitleObj", {
    //   // id: this.draftId || this.currentDraft.draftid,
    //   // title: this.myWorksName || '',
    //   url: "",
    //   type: "draft",
    //   productionPlatform: "web",
    //   duration: this.TOOL.getDuration() / 1000,
    //   optimized: this.TOOL.optimized,
    //   resolution: {
    //     height: 1080.0,
    //     width: 1920.0,
    //   },
    //   contents: [],
    // });
    // this.subtitleEditor.loadUI(this.subtitleObj);
    // this.subtitleEditor.setOption({
    //   width: this.TOOL.clientWidth,
    //   height: this.TOOL.clientHeight,
    //   rootId: "subtitle-player-9999",
    // });

    this.storeMultiDraftMark();
    window.addEventListener(
      "hashchange",
      () => {
        this.storeMultiDraftMark();
      },
      false
    );
    $("body").on("click", this.clickBodyToCloseRiskDrop);
    const vm = this;
    // 生成location hash前，判断加载类型
    let loadType = this.getLoadType();
    this.loadType = loadType;
    this.$store.commit("save_LoadType", loadType);
    // if (loadType === "story" || loadType === "template") {
    if (loadType !== "draft") {
      if (loadType === "template") {
        await this.getTpl();
      }
      this.setLocationHash().then(() => {
        const draftId = this.getUuidInHash();
        this.$store.commit("save_WorksProjectId", draftId);
        this.saveWorks_().then(async () => {
          this.$bus.emit("saveDraftOnOpenPageDone", {
            loadType,
          });
          this.privateDraft = true;
          console.log(`Turbo ~ this.saveWorks_ ~ this.WorksId`, this.WorksId)
          this.currentDraft = {
            draftid: this.WorksId,
            // cooperationType: this.cooperationType
          };
          this.$http
            .get("/api/user/account/cooperation/userInfo")
            .then(({ data: coodata }) => {
              if (
                coodata.code == 200 &&
                coodata.data &&
                coodata.data.state === 0
              ) {
                this.reviewDraft = coodata.data.reviewDraft;
                if (coodata.data.type === 6) this.reviewDraft = 0;
              }
              if (coodata.code === 200) {
                const shareDraft = {};
                shareDraft.shareDarftVersion = {
                  userInfo: {
                    userId: this.UserMsg.id + "",
                    nickname: this.UserMsg.nickname + "",
                    headImgUrl: this.UserMsg.headImgUrl + "",
                  },
                };
                this.currentDraft = {
                  ...(this.currentDraft || {}),
                  shareDraft,
                  userId: this.UserMsg.id
                };
              }
            });
        });
        // if (loadType !== "blank") {
        // }
      });
    }

    this.$store.commit("save_WorksProjectId", this.getUuidInHash());

    if (loadType === "draft") {
      await vm.getWorks();
      // this.$bus.once('loadDraftDone', vm.saveWorks_);
    }
    if (loadType === 'blank') {
      this.onGetUserVersion();
    }
    // loadType === "template" && vm.getTpl();
    // vm.getStory();
    vm.myWorksName = vm.WorksName;

    // 检测同一个项目是否在另一个页面中打开（仅能针对同一个浏览器）
    // let hashid = this.getUuidInHash();
    this.storeMultiDraftMark();
    if ("draft" === loadType) {
      // localStorage[hashid] = Date.now();
      // window.addEventListener(
      //   "storage",
      //   (e) => {
      //     if (e.key === hashid) {
      //       localStorage["_" + hashid] = Date.now();
      //     }
      //     if (e.key === "_" + hashid) {
      //       this.$modal.show("multiDraftMsg");
      //     }
      //   },
      //   false
      // );
    }

    // 轮询是否已保存状态
    // setInterval(() => {
    //   if (!vm.isLock) {
    //     let currJson = vm.TOOL.toJson();
    //     let curr = JSON.stringify({...currJson, id: ''})
    //     let works = JSON.stringify({...vm.worksJson, id: ''})
    //     if (curr === works && vm.saveState !== 'saved') {
    //       vm.saveState = 'saved';
    //       return;
    //     }
    //     if (curr !== works /* && vm.saveState === 'saved' */) {
    //       vm.saveState = 'notSaved';
    //     }

    //   }
    // }, 1000);

    this.$bus.on("drawing_vue", ({ type } = {}) => {
      let msgEl = this.TOOL.content.find(".__empty-msg");
      if (type === "draw") {
        msgEl.css("opacity", 0);
      } else {
        msgEl.css("opacity", 1);
      }
    });

    let handleSaveDraft = () => {
      this.$store.commit("set_WorksSaveState", "notSaved");
      let msgEl = this.TOOL.content.find(".__empty-msg");
      if (msgEl.length && !this.isEmptyEditor()) {
        msgEl.remove();
        this.TOOL.handle.off("click", this.TOOL.handle.data("handler"));
      }
    };

    //画布更改
    eve.on("undo_redo", handleSaveDraft);
    this.$bus.on("undoRedoHandle", handleSaveDraft);
    this.$bus.on("spriteAdded_vue", handleSaveDraft);
    this.$bus.on("tellTopNavSaveState", handleSaveDraft);

    this.$bus.on("topnav.saveWorks", this.saveWorks_);
    this.$bus.on("save", this.saveWorks);

    eve.on("undo_redo", () => {
      console.log('undo_redo', this.changeOriginalDraft);
      this.changeOriginalDraft = true;
    });
    this.$bus.on("undoRedoHandle", () => {
      console.log('undoRedoHandle', this.changeOriginalDraft);
      this.changeOriginalDraft = true;
    });
    // this.$bus.on('app.checkedMaterialOnOpenPage', () => {
    //   this.checkedOnOpenPage = true;
    // });

    this.$bus.on("setTemplateStyle", this.setTemplateStyle);

    this.newVersion = this.$util.localStorage.get("NEW_Version");

    this.$bus.on("updata_new_draft", () => {
      window.location.hash = "/" + uuid.generate();
      let projectId = this.getUuidInHash();
      this.$store.commit("save_WorksProjectId", projectId);
      this.saveWorks_();
    });

    // this.$bus.on("floatingMenu.service", () => {
    //   this.$store.dispatch('showServiceChat');
    // });

    // this.$bus.on('floatingMenu.shortcuts', () => {
    //   const el = this.$refs.itemHelpRef;
    //   const rect = el.getBoundingClientRect();
    //   this.$bus.emit('FeaturesPop_vue', {
    // 		name: 'shortcuts',
    // 		posx : rect.right + 50,
    //     posy : rect.bottom + 72,
    //     type: 1
    // 	});
    // });

    // this.$bus.on("floatingMenu.vip", () => {
    //   let link = document.createElement("a");
    //   link.target = "_blank";
    //   link.href = this.UserLevel === 0 ? "/workplace/vipsolo" : "/workplace/vip";
    //   link.click();
    // });
    // eve.on('globalSoundReady', () => {
    //   this.saveWorks_
    // });

    this.$bc.onmessage = async (ev) => {
      let userID = ev.data.userID;
      if (userID != this.storedUserId) {
        this.loginError = await this.checkMultiLogin();
      }
    };
    window.onstorage = async (e) => {
      const { key, newValue } = e;
      if (key !== "laihuaUserID") return;
      // console.log(`newValue:`,newValue);
      // console.log(` storage.setItem("laihuaUserI:`, localStorage.getItem('laihuaUserID'));
      if (newValue != this.storedUserId) {
        this.loginError = await this.checkMultiLogin();
      }
    };
    this.$bus.on("riskItemLocate", this.onRiskItemLocate);
    this.$bus.on("openSubtitleLayer", this.openSubtitleLayer);
    this.$bus.on('openPresentationTip', this.openPresentationTip);
  },
  mounted() {
    const vm = this;
    this.activateShortcuts = this.isPreventDefault;
    this.$root.$el.addEventListener("click", (ev) => {
      let { target } = ev;
      let btn = this.$refs.exportBtnRef;
      if (btn && btn.contains(target)) {
        return;
      }
      this.isShowPopover = false;
    });
    if (this.$route.template) {
      this.$http
        .get("/api/user/template", {
          params: { id: this.$route.template },
        })
        .then((res) => {
          if (res.data.data.checkId) {
            this.updataTemplatedata = res.data.data;
            this.judgeUpdataTemplate = "updataTemplate";
          } else {
            if (this.UserMsg.type) {
              switch (
              this.UserMsg.type // 组合，场景发布
              ) {
                case 0:
                case 4:
                case 6:
                  this.updataTemplatedata = { id: this.$route.template };
                  this.judgeUpdataTemplate = "updataTemplate";
                  break;
              }
            }
          }
        });
    }
    this.$bus.emit('examineDraftMember', () => {
      this.onVersionSwitch();
    });
    this.$bus.on('versionSwitch', (data) => {
      this.onVersionSwitch(data);
    });
    this.$bus.on("examineDraftMember", (auditor) => {
      this.onExamineDraft(auditor);
    });
    // this.$bus.on("onSendReviewer", (auditor) => {
    //   this.saveWorks_({
    //     coverUrls: this.coverParam,
    //     commitReview: true,
    //   }).then(() => {
    //     this.sendReviewer(auditor);
    //   });
    // });
    this.$bus.on("examineMemberCloase", () => {
      this.isLock = false;
    });

    // vm.$http
    //   .get('/api/promotion/activities')
    //   .then(res => {
    //     let data = res.data.data || {};
    //     vm.templateGame =
    //       vm.UserMsg.type === 2 && data.startActivties.some(v => v.type === 1);
    //   })
    //   .catch(err => console.warn(err));
    this.$bus.on("exportVideo", () => {
      this.showExportDialog();
    });

  },
  beforeDestroy() {
    window.onstorage = null;
    $("body").off("click", this.clickBodyToCloseRiskDrop);
    this.$bus.off("riskItemLocate", this.onRiskItemLocate);
    this.$bus.off("openSubtitleLayer", this.openSubtitleLayer);
    this.$bus.off('openPresentationTip', this.openPresentationTip);
  },
  methods: {
    //Actions
    ...mapActions([
      "refreshHistotyVersionList",
      "deleteHistotyVersion",
      "reloadHistotyVersion",
      "createNewHistotyVersion",
    ]),
    ...mapActions({
      fetchBackupList_p: "draftBackup/fetchList",
      createBackup_p: "draftBackup/createBackup",
      fetchBackupList_c: "draftBackup/fetchList_c",
      createBackup_c: "draftBackup/createBackup_c",
    }),
    ...mapMutations({
      setSceneLibStatus: "materialArea/setSceneLibStatus",
    }),
    toggleVipDropStatus(val) {
      this.vipDropStatus = val;
      val &&
        sensors.track("doratoonGuideePopup", {
          popup_content: "常驻升级", // 弹窗引导内容
          restricted_function: "常驻升级", // 受限功能
          popup_category1: ["个人会员"], // 弹窗分类
        });
    },
    async onGetUserVersion() {
      const resp = await this.$http.get('/api/user/limit?type=draft-work');
      // const userVersion = await this.$http.get("/api/user/info/getUserVersion");
      // if (resp.data.data.draft.num > 0 && userVersion.data.data === 4) {
      //   this.isUserVersion = true;
      // }
      const invitation = localStorage.getItem("invitation");
      if (resp.data.data.work.num >= 8 && !invitation) {
        this.$store.commit('save_TopnavMsg', {
          isInternaInvitation: true
        });
      }
    },
    onRiskHover() {
      clearTimeout(this.timerHideRisk);
      this.$bus.emit("riskDropShow");
      this.editorLoadMore();
      this.riskDropVisible = true;
      const cate = this.componyvipMaterial.length ? "企业会员" : "个人会员";
      sensors.track("doratoonGuideePopup", {
        popup_content: "会员素材-权限", // 弹窗引导内容
        restricted_function: "会员素材-权限", // 受限功能
        popup_category1: [cate], // 弹窗分类
      });
    },
    riskDropMouseOver() {
      clearTimeout(this.timerHideRisk);
    },
    onRiskMouseLeave() {
      // $('.copyrightRisk-drop')[0].style.display = null;
      this.timerHideRisk = setTimeout(() => {
        this.riskDropVisible = false;
        if (this.$refs.riskDropRef) {
          this.$refs.riskDropRef.activeTab = "rights";
        }
      }, 300);
    },
    clickBodyToCloseRiskDrop() {
      this.closeRiskDrop();
    },
    closeRiskDrop() {
      this.riskVisible = false;
      this.riskDropVisible = false;
      if (this.$refs.riskDropRef) {
        this.$refs.riskDropRef.activeTab = "rights";
      }
      // this.$refs.riskDropRef && this.$refs.riskDropRef.setRightsOnly(false);
    },
    isRisk() {
      if (this.CommercialRisk && this.CommercialRisk.length) {
        return true;
      }
      // let noFont = this.IsVipSprites.data.filter((v) => v.fileType != 15);
      // return (
      //   this.hasPayFont() ||
      //   (this.UserMsg.payForMaterial != 1 &&
      //     (noFont.length || this.UserEquity.isEchart))
      // );
      return this.isRightsRisk();
    },
    isRightsRisk() {
      const shouldPaySceneEffect =
        getVipSceneEffects(this.TOOL.sprites).length > 0;
      if (shouldPaySceneEffect) return true;

      const hasMustPay =
        this.UserMsg.payForMaterial != 1 &&
        this.IsVipSprites &&
        this.IsVipSprites.dataLength;

      let removed = this.IsVipSprites.data.filter((v) => v.removed) || [];
      let noFont = this.IsVipSprites.data.filter((v) => v.fileType != 15);
      return (
        removed.length ||
        this.hasPayFont() ||
        hasMustPay ||
        (this.UserMsg.payForMaterial != 1 &&
          (noFont.length || this.UserEquity.isEchart))
      );
    },
    onRiskItemLocate() {
      if (this.riskVisible) {
        return;
      }
      $(".copyrightRisk-drop").css({ display: "block" });
      this.activeTabMemo = this.$refs.riskDropRef.activeTab;
      setTimeout(() => {
        // this.$refs.riskDropRef.activeTab = this.activeTabMemo;
        $(".copyrightRisk-drop")[0].style.display = null;
      }, 1500);
    },
    async fetchBackupList(...args) {
      if (this.IsPrivateDraft) {
        return this.fetchBackupList_p(...args);
      } else {
        return this.fetchBackupList_c(...args);
      }
    },
    async createBackup(...args) {
      if (this.IsPrivateDraft) {
        return this.createBackup_p(...args);
      } else {
        return this.createBackup_c(...args);
      }
    },
    showQuickManu() {
      this.$bus.emit("Modal_vue", { name: "quickManu" });
    },
    togglePreventDefault(val) {
      // 是否启用快捷键
      this.$store.commit("toggle_isPreventDefault", val);
      this.activateShortcuts = val;
    },
    setPathAnim() {
      if (this.TOOL.selectedSprite && this.TOOL.selectedSprite.length) {
        let a = this.TOOL.selectedSprite[0],
          start = this.TOOL.selectedSprite[0].effect.entranceAnim.end,
          end = start + 2000;
        a.updateEffect({
          pathAnim: {
            start: start,
            end: end,
            target: { x: 10, y: 10, rotate: 60, w: 50, h: 100 },
          },
        });
      }
    },
    onVersionSwitch(data) {
      // const v = window.localStorage.getItem('isVersionSwitchNew');
      // if (v || data ==='invitationPopup') {
      //   console.log('11111');
        // this.$message({
        //   message: "正在切换，请稍等...",
        //   type: "success",
        //   duration: 3
        // });
        // sensors.track('laipicBetaVersionSwap', {
        //   swap_type: data ==='invitationPopup' ? '弹窗进入新版' : '切换至新版',
        //   version: '5.6.3'
        // });
        // window.localStorage.setItem("isToNewVersion", "true");
        // // window.location.href = `${ window.location.origin }/newtool/`;
        // this.$http
        //   .post("/api/user/draft/copy", {
        //     id: window.location.hash.slice(2),
        //   })
        //   .then((res) => {
        //     if (res.data.code === 200) {
        //       const copyDraftId = res.data.data.uid;
        //       window.open(`${ window.location.origin }/newtool/#/${ copyDraftId }`);
        //       //  window.location.href = `${window.location.origin}/newtool/#/${copyDraftId}`;
        //     } else if (res.data.code === 412) {
        //       this.onClose();
        //       this.$memberGuide({
        //         show: true,
        //         funcRight: {
        //           type: "draftNumber",
        //           name: "草稿数量",
        //         },
        //       });
        //     }

        //   });

      // } else {
        this.$store.commit('save_TopnavMsg', {
          isVersionSwitchNew: true,
          versionSwitchNewType: data ==='invitationPopup' ? '弹窗进入新版' : '切换至新版',
        });
      // }

    },
    async playWhole() {
      if (this.isShowScenesLoading) return;
      sensors.track('previewVideo', {
        version: ''
      });
      document.querySelector(".editorBtn .btn-sound").style.display = "none";
      // if (this.isPersonVideosExcess()) {
      //   let pvLimit = this.UserEquity.draftVideo;
      //   let msg = pvLimit === 1
      //     ? '您添加的视频素材大于1个，升级个人VIP可扩充到3个，如需导出请删除或者升级会员。'
      //     : pvLimit === 3 ? '您添加的视频素材大于3个，开通企业会员可无限使用，如需导出请删除或者开通企业会员。' : ''
      //   this.$message({
      //     message: msg,
      //     type: 'error',
      //   })
      //   return;
      // }

      //关闭素材面板-场景页
      // this.$bus.emit("materialPane_vue", { type: "scenes" });
      this.setSceneLibStatus("pack-leave");
      this.$bus.emit("stop_listen_BGM");
      // 画布恢复正常大小
      if (this.TOOL.option.scale !== 1) {
        this.TOOL.setOption({
          width: this.Tool_Size.width,
          height: this.Tool_Size.height - 40,
          scale: 1,
          surplusY: this.TopNav_Size.height + 40,
          surplusX: this.MaterialPane_Size.width,
        });
      }
      let someUnloaded = this.TOOL.sprites.some((v) => {
        return v.fromJsonLoadingState < 1 && v.unLoadData.json;
      });
      if (someUnloaded) {
        //对未加载的场景页进行加载
        //let initArr = [];
        this.$bus.emit("loadingAllScenes", "start");
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          const scenes = this.TOOL.sprites[i];
          if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
            await this.TOOL.selectScenes(scenes);
            await scenes.fromJson(
              scenes.unLoadData.json,
              this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
              true
            );
          }
          //初始化一些动画资源
          await scenes.activeAnimation();
        }
        this.$bus.emit("loadingAllScenes", "end");
      } else {
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          const scenes = this.TOOL.sprites[i];
          await scenes.activeAnimation();
        }
      }

      //初始化字幕界面
      // if (this.subtitleEditor) {
      //   this.subtitleEditor.loadUI(this.subtitleObj);
      //   this.subtitleEditor.setOption({
      //     width: this.TOOL.clientWidth,
      //     height: this.TOOL.clientHeight,
      //     rootId: "subtitle-player-9999",
      //   });
      // }

      //弹出预览层
      this.$bus.emit("Modal_vue", {
        name: "preview",
        data: {
          type: "preview",
        },
      });
    },

    /**
     * 指定时间截图
     *
     */
    async getSnapByDom2(dom, { sec, scene } = {}) {
      let jqPlayer = this.TOOL.player.ele;
      jqPlayer.show();
      dom.style.display = "";
      let extraShowEl = [];

      let $video = $(dom).find("video");
      if ($video[0]) {
        let flag = await this.beforeGetSnap({ palyerScene: dom, sec, scene });
      }

      return new Promise((resolve) => {
        domtoimage
          .toBlob2(dom, {
            bgcolor: "transparent",
            _width: dom.offsetWidth,
            _height: dom.offsetHeight,
            width: 640,
            height: (640 * dom.offsetHeight) / dom.offsetWidth,
            quality: 0.5,
            style: {
              overflow: "hidden",
            },
            filter: (node) => {
              try {
                if ($(node).css("display") === "none") {
                  return false;
                }
              } catch (e) { }

              let isPass = true;

              let notVideo = node.tagName !== "VIDEO";
              isPass = notVideo;
              let isImg = node.tagName === "IMG";
              let isHandWriteSvg =
                node.classList &&
                node.classList.contains("_my-hand-player-svg");
              if (isHandWriteSvg) {
                $(node).parent().css("display") !== "none" &&
                  extraShowEl.push($(node).next().show());
              }
              let hasSpecial =
                node.classList &&
                (node.classList.contains("frame-image") || isHandWriteSvg);
              if (hasSpecial) {
                isPass = false;
              }
              if (isImg) {
                isPass = node.src && node.src.length > 0;
              }

              return isPass;
            },
          })
          .then((blob) => {
            if (extraShowEl.length) {
              extraShowEl.forEach((el) => {
                el.hide();
              });
            }

            if (this.TOOL.optimized !== "Horizontal") {
              let height = (640 * dom.offsetHeight) / dom.offsetWidth;
              let width = (height * 9) / 16;
              setBlobImageSize({
                blob,
                height,
                width,
                sx: (640 - width) / 2,
                sy: 0,
                sw: width,
                sh: height,
              }).then((blob) => {
                this.snaps.push({
                  blob,
                  // url: this.getBlobUrl(blob)
                });
                dom.style.display = "none";
                jqPlayer.hide();
                resolve();
              });

              return;
            }

            this.snaps.push({
              blob,
              // url: this.getBlobUrl(blob)
            });
            dom.style.display = "none";
            jqPlayer.hide();
            resolve();
          })
          .catch((err) => {
            console.warn(err);
            dom.style.display = "none";
            jqPlayer.hide();
            resolve();
          })
          .finally(() => {
            this.TOOL.sprites.forEach(scene => {
              scene.sprites.forEach(sprite => {
                if (sprite.type === 'Video') {
                  const ele = document.getElementById('sprite-' + sprite.id);
                  ele.style.backgroundImage = '';
                  const playerEle = document.getElementById('player-sprite-' + sprite.id);
                  playerEle.style.backgroundImage = '';
                }
              });
            });
          });
      });
    },
    getBlobUrl(blob) {
      return window.URL.createObjectURL(blob || new Blob());
    },

    listenVisibilitychange() {
      var hidden, visibilityChange;
      if (typeof document.hidden !== "undefined") {
        // Opera 12.10 and Firefox 18 and later support
        hidden = "hidden";
        visibilityChange = "visibilitychange";
      } else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
      } else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
      }

      document.addEventListener(
        visibilityChange,
        handleVisibilityChange.bind(this)
      );
      async function handleVisibilityChange() {
        if (document[hidden]) {
          // this.saveWorks();
          this.screenParam = "";
          this.intervalSaveWorksInner();
        } else {
          // this.loginError = 'checking';
          this.loginError = await this.checkMultiLogin();
        }
      }
    },

    // 打开页面，第一次自动保存时截图保存一次，
    // 离开当前界面时，截图保存一次，截图截当前所见。
    // 其余自动保存不截图。
    intervalSaveWorks() {
      const vm = this;
      if (vm.tid) {
        return;
      }
      vm.tid = setInterval(this.intervalSaveWorksInner, vm.saveDraftInterval);
    },
    async intervalSaveWorksInner() {
      this.checkTrialExpire();
      // 审核
      if (this.isPassDraft === 6) {
        return;
      }

      const vm = this;
      if (vm.saveState === "saved") {
        // 自动保存，项目无变化
        return;
      }
      if (this.isEmptyEditor()) {
        // 无素材, 空项目
        return;
      }
      // 开始自动保存项目'
      if (this.isLock) {
        return;
      }
      this.isLock = true;
      this.unlockDelay();
      this.$store.commit("set_WorksSaveState", "saving");
      if (!this.screenParam) {
        try {
          this.screenParam = await this.uploadThumbnail();
        } catch (err) {
          this.screenParam = "";
        }
      }

      return vm.saveWorks_({
        coverUrls: this.coverParam,
      });
    },
    //入口
    async getWorks() {
      const vm = this;
      // hash
      let id = this.getUuidInHash() || this.$route.projectId;
      if (!id) return;

      let { data: coodata } = await this.$http.get(
        "/api/user/account/cooperation/userInfo"
      );

      let firstdata = { code: 10043 };
      if (coodata.code == 200 && coodata.data && coodata.data.state === 0) {
        this.reviewDraft = coodata.data.reviewDraft;
        if (coodata.data.type === 6) this.reviewDraft = 0;
        firstdata = await this.keepAlive(id, true);
        if (firstdata.code === 412) return;
        // //console.log("判断团队模版", firstdata, "id:", id);
      }

      let draftid = id;
      let keepAliveId =
        firstdata.code === 10044 || firstdata.code === 10049
          ? firstdata.data
          : null;
      this.getUserExportVedio()
      try {
        let res = {};
        if (firstdata.code === 10044 || firstdata.code === 10049) {
          this.privateDraft = false;
          //使用 api/user/account/cooperation/draft 获取协作id 和 协作项目数据
          res = await this.$http.post("/api/user/account/cooperation/draft", {
            id: draftid,
            edit: 1,
          });
          const resp = await this.$http.get('/api/user/limit?type=draft-work');
          const invitation = localStorage.getItem("invitation");
          if (resp.data.data.work.num >= 8 && !res.data.data.ppt && !invitation) {
            this.$store.commit('save_TopnavMsg', {
              isInternaInvitation: true
            });
          }
          window.draftId = draftid;
          // this.$store.commit("save_WorksProjectId", null);

          //console.log("团队模版数据", res.data, "登录用户", this.UserMsg);
        } else {
          this.privateDraft = true;
          res = await this.$http.get("/api/user/draft", {
            params: {
              pIndex: 1,
              fPage: 100,
              id: draftid,
            },
          });
          const jsonString = res.data.data && res.data.data.data;
          console.log({jsonString})
          try {
            JSON.parse(jsonString)
          } catch (e) {
            if (/\.json$/.test(jsonString)) {
              const d = await (await fetch(this.$handleAssetsUrl(jsonString))).json();
              if (res.data.data) {
                res.data.data.data = JSON.stringify(d);
              }
            }
          }
          const invitation = localStorage.getItem("invitation");
          const resp = await this.$http.get('/api/user/limit?type=draft-work');
          if (resp.data.data.work.num >= 8 && !res.data.data.ppt && !invitation) {
            this.$store.commit('save_TopnavMsg', {
              isInternaInvitation: true
            });
          }
        }

        if (res.data.data.caption) {
          var subobj;
          try {
            subobj = JSON.parse(res.data.data.caption);
          } catch (e) {
            console.error("字幕资源出错", e);
          }
          //console.log("获取字幕信息", res.data.data, subobj, subobj && subobj.id);
          if (subobj && subobj.type) {
            this.$store.commit("subtitle/setSubtitleObj", subobj);
            // 为了场景页播放
            this.subtitleEditor.loadUI(this.subtitleObj);
            this.subtitleEditor.setOption({
              width: this.TOOL.clientWidth,
              height: this.TOOL.clientHeight,
              rootId: "subtitle-player-9999",
            });
          }
        }

        let draftInfo = await this.$http.get(
          "/api/user/draftInfo?draftId=" + draftid
        );
        let cooperationAudios = [];
        const otherInfoUrl = res.data.data.otherInfos;
        if (otherInfoUrl) {
          cooperationAudios =
            (await this.getCooperationAudios(otherInfoUrl)) || [];
        }
        let audios =
          (draftInfo &&
            draftInfo.data &&
            draftInfo.data.data &&
            draftInfo.data.data.audios) ||
          [];
        audios = [...audios, ...cooperationAudios];
        audios.some((v) => {
          if (v.speaker === "x2_qianxue") {
            v.speaker = "x2_qianxue2";
            return true;
          }
        });
        if (audios) {
          this.$store.commit("smartVoice/setWorksList", audios);
        }

        // if (this.privateDraft) {
        //   this.postDraft(res.data.data, audios);
        // }

        let { data } = res;
        let code = data.code;
        if (code !== 200) {
          console.warn(`${ data.msg }，获取作品项目失败`);
        }
        if (code !== 200 && code !== 403) {
          return;
        }
        if (!data.data || code === 403) {
          // 无此项目，重新生成uuid
          await this.setLocationHash();
          this.$store.commit("save_WorksProjectId", this.getUuidInHash());
          this.intervalSaveWorks();
          this.TOOL.loading.status = "success";
          this.setAllVideosReady();
          vm.$bus.emit("updateAllScenes", this.TOOL.sprites);

          // 无此项目
          this.$bus.emit("hintMessage_vue", { data: false });

          // 从模板或故事板进入，不保存的情况下刷新后，依然显示模板或故事板
          if (this.$route.template) {
            this.getTpl();
          }
          if (this.$route.storyboard) {
            this.getStory();
          }
          return;
        }
        this.isPassDraft = data.data.isPass;
        this.isDraftExist = true;
        this.currentDraft = data.data;
        this.currentDraft.draftid = draftid;
        this.currentDraft.keepAliveId = keepAliveId;
        await this.loadCooperation();

        if (coodata.code === 200 && coodata.data && coodata.data.state === 0) {
          setInterval(() => {
            this.keepAlive(this.currentDraft.keepAliveId);
          }, 5500);
        }

        let {
          data: worksJson,
          id,
          projectId,
          title,
          userId: draftOwnerId,
        } = data.data;

        this.draftOwnerId = draftOwnerId;
        worksJson = JSON.parse(worksJson);

        //console.log
        if (typeof worksJson !== "object") {
          // throw new Error('未取得作品数据');
          worksJson = JSON.parse(worksJson);
        }
        this.$store.commit('previewControls/draftBeforeRender', worksJson);
        this.judgeVip_worksDraftNum().then((vipdata) => {
          this.TOOL.fromJson(worksJson)
            .then(() => {
              vm.$bus.emit("updateAllScenes", this.TOOL.sprites);
              vm.$store.commit("set_WorksSaveState", "saved");
            })
            .then(() => {
              this.$bus.emit("hintMessage_vue", { data: true });
              // console.log(
              //   "(userType||UserTeamInfo!=null) && !(reviewDraft && (isPassDraft !== 6 || (isPassDraft === 6 && changeOriginalDraft))",
              //   this.userType || this.UserTeamInfo != null,
              //   !(
              //     this.reviewDraft &&
              //     (this.isPassDraft !== 6 ||
              //       (this.isPassDraft === 6 && this.changeOriginalDraft))
              //   ),
              //   this.reviewDraft,
              //   this.isPassDraft
              // );
              if (this.isPassDraft === 6) {
                this.$modal.show("commitReviewPass", {
                  title: "",
                  content: "",
                  btns: ["Close", "Cancel", "Ok"],
                  resultHandler: (type) => {
                    if (type == "Ok") {
                      this.showExportDialog();
                    }
                  },
                });
              }
            });
          vm.$store.commit("save_WorksProjectId", projectId);
          vm.$store.commit("save_WorksId", id);
          vm.storeMultiDraftMark(id);
          vm.$store.commit("save_WorksName", title);
          vm.myWorksName = this.WorksName;
          // vm.$bus.emit('loadDraftDone');
        });
      } catch (error) {
        console.warn(error);
      }
    },
    async postDraft(data = {}, audios = {}) {
      const otherInfos = JSON.stringify({
        audios,
      });
      const { data: res } = await this.$http.post("/api/user/draft", {
        ...data,
        otherInfos,
      });
      if (res.code === 413) {
        this.showExportedMsg();
      }
    },
    async keepAlive(id, first = false) {
      if (!id) return;
      //let siToken = null;
      let { data } = await this.$http.post(
        "/api/user/account/cooperation/keepAlive",
        {
          id: id,
        }
      );

      let closeLoading = () => {
        setInterval(() => {
          let div = document.getElementsByClassName("pace  pace-inactive")[0];
          if (div) div.style.display = "none";
        }, 700);
      };

      if (data.code === 10048) {
        closeLoading();
        this.$modal.show("MessageDialog", {
          title: "提示",
          content:
            "监测到该协作项目由其他协作者正在编辑，请在对方编辑完后再进入。",
          btns: ["Close"],
          resultHandler: (type) => {
            window.location.href = window.origin + "/workplace/dashboard/creator/all";
          },
        });
      } else if (data.code === 412) {
        closeLoading();
        this.$modal.show("MessageDialog", {
          title: "提示",
          content: "协同项目不存在。",
          btns: ["Close"],
          resultHandler: (type) => {
            window.location.href = window.origin + "/workplace/dashboard/studio/drafts/draft-anim";
          },
        });
      }

      if (first) return data;
      if (data.code === 10049) {
        closeLoading();
        this.$modal.show("MessageDialog", {
          title: "提示",
          content: "监测到该项目数据有其他协作者更新，请刷新获取最新的数据。",
          btns: ["Cancel", "OK", "Close"],
          resultHandler: (type) => {
            window.location.reload();
          },
        });
      }
      return data;
    },
    async loadCooperation() {
      this.currentDraft.cooperationType = 0;
      //数据兼容
      if (
        !this.currentDraft.shareDraft &&
        this.currentDraft.shareDarftVersion
      ) {
        this.currentDraft.shareDraft = {};
        this.currentDraft.shareDraft.shareDarftVersion =
          this.currentDraft.shareDarftVersion;
      }

      let { data } = await this.$http.get(
        "/api/user/account/cooperation?sOfPage=99999&fPage=99999"
      );

      if (data.code !== 200) {
        this.currentDraft.cooperationType = -1;
      }

      if (data.data && data.data.length) {
        const element = data.data.find(
          (x) => x.cooperatorId === this.UserMsg.id
        );
        if (element) {
          this.currentDraft.cooperationType = element.type;
        } else {
          this.currentDraft.cooperationType = -1;
        }

        //团队成员的，普通项目，所有者
        if (
          !this.currentDraft.shareDarftVersion &&
          this.currentDraft.cooperationType >= 0 &&
          this.UserMsg.id === this.currentDraft.userId
        ) {
          this.currentDraft.shareDraft = {};
          this.currentDraft.shareDraft.shareDarftVersion = {
            userInfo: {
              userId: this.UserMsg.id + "",
              nickname: this.UserMsg.nickname + "",
              headImgUrl: this.UserMsg.headImgUrl + "",
            },
          };
        }

        this.$store.commit(
          "setCooperationType",
          this.currentDraft.cooperationType
        );
        this.$store.commit(
          "setShowCooperationBtn",
          this.currentDraft.userInfo &&
          this.currentDraft.userId === this.UserMsg.id &&
          this.currentDraft.cooperationType >= 0
        );

        this.$store.commit(
          "setCooperationDraftOwnerId",
          this.currentDraft.userId
        );
      }
      if (
        this.currentDraft.shareDraft &&
        this.currentDraft.shareDraft.shareDarftVersion &&
        this.currentDraft.shareDraft.shareDarftVersion.userInfo
      ) {
        this.currentDraft.shareDraftId = this.currentDraft.id;
        this.$store.commit("setCooperationDraft", this.currentDraft);

        //获取版本列表
        this.refreshHistotyVersionList();

        let item = this.currentDraft.shareDraft.shareDarftVersion.userInfo;
        if (item.headImgUrl) item.headImgUrl = item.headImgUrl.split(",");
        if (item.nickname) item.nickname = item.nickname.split(",");
        if (item.userId) item.userId = item.userId.split(",");
      }

      if (this.currentDraft.cooperationType === -1)
        this.$store.commit("setShowCooperationBtn", true);
    },
    clickCooperation() {
      //console.log(this.cooperationType, this.currentDraft);
      if (this.UserTeamInfo && this.UserTeamInfo.state === 5) {
        this.$modal.show("MessageDialog", {
          content:
            "您的团队已过期，暂不可继续使用协作功能。",
          btns: [{ type: "ok", content: "了解更多" }, 'Close'],
          resultHandler: (type) => {
            if (type === 'ok') {
              window.open(window.origin + '/workplace/dashboard/team/members');
            }
          },
        });
        return;
      }
      // if (this.cooperationType >= 0 && !this.currentDraft) {
      //   //console.log("个人项目转协同 this.draftId", this.draftId);
      //   this.saveWorks().then(() => {
      //     this.$modal.show("MessageDialog", {
      //       title: "提示",
      //       content:
      //         "邀请用户参与编辑协作，需要升级为协作模式，系统将会为您自动保存并重新加载项目。",
      //       btns: ["Cancel", "Ok"],
      //       resultHandler: (type) => {
      //         if (type == "Ok") {
      //           let { origin, pathname } = window.location;
      //           window.location.assign(
      //             origin +
      //             pathname +
      //             "?time=" +
      //             new Date().getTime() +
      //             "#/" +
      //             this.draftId
      //           );
      //         }
      //       },
      //     });
      //   });
      // } else
      console.log('团队信息', this.UserTeamInfo);
      if (this.cooperationType < 0 && !this.UserTeamInfo) {
        this.$modal.show("MessageDialog", {
          content:
            "协作为团队专属功能，您当前未创建或加入任何团队，暂无法使用。",
          btns: [{ type: "ok", content: "了解更多" }, 'Close'],
          resultHandler: (type) => {
            if (type === 'ok') {
              window.open(window.origin + "/workplace/dashboard/studio/drafts/draft-anim");
            }
          },
        });
      } else if (( (this.currentDraft || {}).cooperationType || this.cooperationType ) >= 0) {
        this.dialogVisible = true;
      }
      // else if (this.currentDraft.cooperationType >= 0) {
      //   this.dialogVisible = true;
      // }
    },
    async closeCooperationDialog(e) {
      this.dialogVisible = false;
      // console.log("closeCooperationDialog 个人项目转协同", e);
      if (e && this.privateDraft) {
        this.privateDraft = null;
        let { data } = await this.$http.post(
          "/api/user/account/cooperation/draft",
          {
            id: this.currentDraft.draftid,
            edit: 1,
          }
        );
        if (data.code === 200) {
          let { data: coodata } = await this.$http.get(
            "/api/user/account/cooperation/userInfo"
          );
          this.reviewDraft = coodata.data.reviewDraft;
          if (coodata.data.type === 6) this.reviewDraft = 0;

          let { id } = data.data;
          this.currentDraft.shareDraft = {};
          this.currentDraft.shareDraft.shareDarftVersion = {
            userInfo: {
              userId: this.UserMsg.id + "",
              nickname: this.UserMsg.nickname + "",
              headImgUrl: this.UserMsg.headImgUrl + "",
            },
          };
          this.currentDraft.id = id;
          this.currentDraft.keepAliveId = id;
          this.currentDraft.projectId = id;
          this.currentDraft.shareDraftId = id;
          this.$store.commit("save_WorksProjectId", id);
          this.$store.commit("save_WorksId", id);
          vm.storeMultiDraftMark(id);
          this.$store.commit(
            "setCooperationDraftOwnerId",
            this.currentDraft.userId
          );
        }
      }
    },
    async confirmSend() {
      if (this.checkboxValue) {
        const v = window.localStorage.setItem("examineDraft", 'true');
      }
      await this.onExamineDraft();
    },
    runConfirmReviewDraft() {
      let commit = async () => {
        this.$store.commit("set_WorksSaveState", "notSaved");
        if (this.isLock) {
          this.$bus.emit("saveWorks.completed");
          return;
        }
        this.isLock = true;
        this.unlockDelay();
        this.$store.commit("set_WorksSaveState", "saving");
        try {
          if (this.reviewDraft === 0) {
            this.$store.commit('save_TopnavMsg', {
              isExamineMember: true
            });
            return;
          } else {
            const v = window.localStorage.getItem("examineDraft");
            if (v) {
              this.onExamineDraft();
            } else {
              this.isExamineDialogVisible = true;
            }
          }
        } catch (err) {
          console.warn(err);
          this.$store.commit("set_WorksSaveState", "notSaved");
          this.saveWorks_({
            coverUrls: this.coverParam,
          });
        }
      };

      let checkVip = () => {
        if (this.isRightsRisk()) {
          this.$modal.show("commitReviewRisk", {
            title: "",
            content: this.IsVipSprites.dataLength,
            btns: ["Close", "Cancel", "Ok"],
            resultHandler: (type) => {
              if (type === "Ok") {
                // this.delVip();
                $(".copyrightRisk-drop")[0].style.display = 'block';
              } else if (type === "Cancel") {
                commit();
              }
            },
          });
        } else commit();
      };

      let val = Cookies.get("laihua_commitReviewConfirm_ignore");
      if (!val) {
        this.$modal.show("commitReviewConfirm", {
          title: "",
          content:
            "提交审核之后，在审核结果返回之前，项目将不可继续进行编辑，是否确认提交审核？",
          btns: ["Close", "Cancel", "Ok"],
          resultHandler: (type) => {
            if (type === "Ok") {
              checkVip();
            }
          },
        });
      } else checkVip();
    },
    async commitReviewDraft() {
      await this.runConfirmReviewDraft();
    },
    async onExamineDraft(auditor = '') {
      this.isDisabled = true;
      let val = await this.uploadThumbnail();
      this.screenParam = val;
      await this.$http.post("/api/user/draft/updateThumbnail", {
        screen: val,
        draftId: this.IsPrivateDraft
          ? this.WorksId || this.WorksProjectId
          : this.cooperationDraftId,
      });
      await this.saveWorks_({
        coverUrls: this.coverParam,
        commitReview: true,
        auditor
      });
      if (this.saveWorksValue.status === 200) {
        window.onbeforeunload = null;
        window.location.replace(window.origin + "/workplace/dashboard/creator/all");
      } else {
        this.isDisabled = false;
      }
    },
    async openSubtitleLayer() {
      this.closeRiskDrop();

      // this.TOOL.player.ele.addClass('hide');
      // this.$store.commit("subtitle/setOpenSubtitle", true);
      this.$bus.emit("FeaturesPop_close_vue", {
        type: 3,
      });

      this.$store.commit("toggle_isPreventDefault", false);
      this.TOOL.selectSprite();

      if (this.TOOL.option.scale !== 1) {
        this.TOOL.setOption({
          width: this.Tool_Size.width,
          height: this.Tool_Size.height - 40,
          scale: 1,
          surplusY: this.TopNav_Size.height + 40,
          surplusX: this.MaterialPane_Size.width,
        });
      }
      let someUnloaded = this.TOOL.sprites.some((v) => {
        return v.fromJsonLoadingState < 1 && v.unLoadData.json;
      });
      if (someUnloaded) {
        //对未加载的场景页进行加载
        let sIndex = this.TOOL.sprites.indexOf(this.SelectScenes_Msg);
        this.$bus.emit("loadingAllScenes", "start");
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          const scenes = this.TOOL.sprites[i];
          if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
            await this.TOOL.selectScenes(scenes);
            await scenes.fromJson(
              scenes.unLoadData.json,
              this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
              true
            );
          }
          //初始化一些动画资源
          await scenes.activeAnimation();
          await scenes.effect.init();
        }
        this.TOOL.selectScenes(this.TOOL.sprites[sIndex]);
        this.$bus.emit("loadingAllScenes", "end");
      } else {
        for (let i = 0; i < this.TOOL.sprites.length; i++) {
          const scenes = this.TOOL.sprites[i];
          await scenes.activeAnimation();
          await scenes.effect.init();
        }
      }

      if (this.TOOL && (!this.subtitleObj || !this.subtitleObj.type)) {
        console.log(
          "没有字幕数据",
          !this.subtitleObj,
          !this.subtitleObj.type,
          this.subtitleObj
        );
        this.$store.commit("subtitle/setSubtitleObj", {
          id: this.draftId || this.currentDraft.draftid,
          title: this.myWorksName,
          url: "",
          type: "draft",
          productionPlatform: "web",
          duration: this.TOOL.getDuration() / 1000,
          optimized: this.TOOL.optimized,
          resolution: {
            height: 1080.0,
            width: 1920.0,
          },
          contents: [],
        });
      }
      if (this.subtitleObj && this.TOOL) {
        this.subtitleObj.optimized = this.TOOL.optimized;
      }
      if (this.subtitleEditor) {
        this.subtitleEditor.loadUI(this.subtitleObj);
      }

      this.$store.commit("subtitle/setOpenSubtitle", true);
    },
    getTpl() {
      const vm = this;
      let id = this.$route.template,
        style = this.$route.style;
      if (!id) {
        return Promise.resolve();
      }
      // this.$http.get('/api/common/material', {
      return this.$http
        .get("/api/common/material/templateData", {
          params: {
            // pIndex: 1,
            // fPage: 100,
            id,
            // type: 8,
          },
        })
        .then(async (res) => {
          let { data } = res;

          if (data.code === 200) {
            let commercialResp = await this.$http.post(
              "/api/user/material/checkCommercial",
              {
                dataList: JSON.stringify([{ id: data.data.id }]),
                // draftId: this.WorksId
              }
            );
            let commercial = commercialResp.data.data;
            if (commercial && commercial.length) {
              this.TOOL.isTplCommercial = 1;
            } else {
              this.TOOL.isTplCommercial = 0;
            }
          }

          let {
            data: worksJson,
            id,
            projectId,
            title,
            templateStyle,
          } = data.data;
          let jsonPass = true;
          try {
            worksJson = JSON.parse(worksJson);
            worksJson.scenes.forEach((scene = {}) => {
              scene.exitEffect && delete scene.exitEffect.manual;
              scene.sprites.forEach((sprite) => {
                if (sprite.artType) {
                  sprite.templateFree = true;
                }
              });
            });
          } catch (err) {
            jsonPass = false;
          }
          if (typeof worksJson !== "object" || !jsonPass) {
            throw new Error("未取得作品数据");
          }
          this.templateid = id;
          this.templateStyle = templateStyle;
          if (!style && templateStyle) {
            this.$store.commit("toggle_StyleDataMsg", {
              // 切换style详细数据
              id: templateStyle.styleId,
            });
            this.$store.commit("save_TemplateStyle", templateStyle.styleId);
          }

          if (this.$route.direction == 2) {
            worksJson.optimized = "Vertical";
          }
          this.judgeVip_worksDraftNum().then((vipdata) => {
            if (!vipdata) {
              this.TOOL.fromJson(worksJson, "tpl")
                .then(() => {
                  vm.$bus.emit("updateAllScenes", this.TOOL.sprites);
                })
                .then(() => {
                  this.$bus.emit("hintMessage_vue", { data: true });
                  // 封面截图
                  // this.saveDraftAfterThumb();
                  this.$http
                    .get(`/api/common/material?type=8&id=${ id }`)
                    .then((res) => {
                      console.log('导出的接口', res);
                      if (res.data.data.thumbnailUrl) {
                        return this.saveWorks_({
                          coverUrls: res.data.data.thumbnailUrl,
                        });
                      } else {
                        return this.saveWorks_();
                      }
                    })
                    .catch((err) => {
                      return this.saveWorks_();
                    })
                    .then(() => {
                      this.$bus.emit("saveDraftOnTplGot");
                    });
                });
              vm.$store.commit("save_WorksName", this.myWorksName);
            }
          });
          // this.myWorksName = worksJson.title
          this.myWorksName = title || worksJson.title || void 0;
          if (!this.myWorksName) {
            this.myWorksName = await this.getUntitle();
          }
        })
        .catch(async (err) => {
          this.myWorksName = await this.getUntitle();
          console.warn(err);
        });
    },
    setTemplateStyle() {
      this;
      if (!this.templateStyle) {
        return;
      }
      this.$store.commit("toggle_StyleDataMsg", {
        // 切换style详细数据
        id: this.templateStyle.styleId,
      });
    },
    getStory() {
      if ("storyboard" in this.$route) {
        let worksJson = this.$util.localStorage.get("storyBoardData");
        // worksJson = JSON.parse(worksJson);
        this.judgeVip_worksDraftNum().then((vipdata) => {
          if (!vipdata) {
            this.TOOL.fromJson(worksJson, "tpl")
              .then(() => {
                this.$bus.emit("updateAllScenes", this.TOOL.sprites);
              })
              .then(() => {
                this.$bus.emit("hintMessage_vue", { data: true });
              })
              .catch((err) => {
                console.warn(err);
              });
            vm.$store.commit("save_WorksName", this.myWorksName);
          }
        });
        this.myWorksName = worksJson.title;
      }
    },
    setEditable() {
      this.isNameEditable = true;
      this.myWorksNameOld = this.myWorksName;
      this.$nextTick(() => {
        this.$refs.worksNameRef.focus();
      });
    },
    changeWorksName() {
      this.isNameEditable = false;
      if (!this.myWorksName) {
        this.myWorksName = this.myWorksNameOld;
      }
      if (this.myWorksNameOld !== this.myWorksName) {
        this.$store.commit("set_WorksSaveState", "notSaved");
      }
      this.saveWorksName();
    },
    onTitleInputEnter(ev) {
      ev.target.blur();
    },
    saveWorksName() {
      this.$store.commit("save_WorksName", this.myWorksName);
    },
    toggleHover(flag) {
      this.isComponentHover = flag;
    },
    async ifShowQR() {
      const resp = await this.$http.get('/api/user/limit?type=draft-work-transform');
      const { code, data } = resp.data;
      if (code === 200 && data && data.work.num === 0) {
        this.QRVisible = true;
      }
    },

    // 获取已付费的IP
    async getIPRole() {
      let scene = this.TOOL.sprites;
      console.log(`Turbo ~ this.$bus.on ~ scene:`, scene);
      let IPRoleLists = [];
      const useIpList = [];
      for (let i = 0; i < scene.length; i++) {
        const IPRoleList = scene[i].sprites.filter((item) => item.option.fileType === 10);
        console.log(`Turbo ~ this.$bus.on ~ IPRoleList:`, IPRoleList);
        useIpList.push(...IPRoleList);
        IPRoleList.forEach((item) => {
          IPRoleLists.push({
            id: item.option.resourceId,
            fileType: item.option.fileType,
            uuid: item.id,
            sceneId: item.option.scenesId
          });
          console.log(`Turbo ~ IPRoleList.forEach ~ IPRoleLists:`, IPRoleLists);
        })
      }
      console.log(`Turbo ~ IPRoleList.forEach ~ IPRoleLists:`, IPRoleLists);
      this.useIpLists = useIpList;
      this.$bus.emit('getUseIpList', this.useIpLists);
      const resp = await this.$http.post('/api/user/material/checkMaterial', {
        dataList: JSON.stringify(IPRoleLists),
        draftId: this.WorksId
      })
      console.log(`Turbo ~ this.$bus.on ~ resp:`, resp);
      if (resp.data.code !== 200) {
        return;
      }

      if (resp.data.data.ipPayList) {
        // 获取所有付费IP的动作
        const filterIPRole = [];
        for (const item of resp.data.data.ipPayList) {
          const res = await this.$http.get('/api/common/character/actionsAndCharacter', {
            params: {
              id: item.id
            }
          })
          filterIPRole.push(res.data.data);
        }
        console.log(`Turbo ~ this.$bus.on ~ filterIPRole:`, filterIPRole);

        // 过滤同个IP中的不同动作
        const filteredIPRole = () => {
          const map = new Map();
          for (let i = 0; i < filterIPRole.length; i++) {
            if (!map.has(filterIPRole[i].uid)) {
              map.set(filterIPRole[i].uid, filterIPRole[i]);
            }
          }
          return [...map.values()];
        }
        const filteredIPRoleList = filteredIPRole();
        console.log(`Turbo ~ this.$bus.on ~ filteredIPRoleList:`, filteredIPRoleList);

        let ipPayList = [];
        // 已付费的 ip 数量
        let ipPayedCount = 0;
        // 所有要付费的 ip 数量
        let ipListCount = 0;
        // 未付费的 ip 数量
        let ipPayCount = 0;
        if (resp.data.code === 200) {
          ipPayList = resp.data.data.ipPayList;
          const filteredIPList = () => {
            const map = new Map();
            for (let i = 0; i < resp.data.data.ipList.length; i++) {
              if (!map.has(resp.data.data.ipList[i].id)) {
                map.set(resp.data.data.ipList[i].id, resp.data.data.ipList[i]);
              }
            }
            return [...map.values()];
          };
          const filteredIpList = filteredIPList();
          ipListCount = filteredIpList.length;

          const filterIpPayList = () => {
            const map = new Map();
            for (let i = 0; i < resp.data.data.ipPayList.length; i++) {
              if (!map.has(resp.data.data.ipPayList[i].id)) {
                map.set(resp.data.data.ipPayList[i].id, resp.data.data.ipPayList[i]);
              }
            }
            return [...map.values()];
          };
          const filteredIpPayList = filterIpPayList();
          ipPayCount = filteredIpPayList.length;
          ipPayedCount = ipListCount - ipPayCount;
          console.log(ipPayCount);
          console.log(ipPayedCount);

          if (ipPayList.length !== 0) {
            this.$modal.show('IPRolePayTip', {
              ipPayList: ipPayList,
              filteredIPRoleList: filteredIPRoleList
            });
            return ipPayList.length;
          } else if (ipPayedCount !== 0) {
            this.$modal.show('IPRoleExport', {
              ipPayedCount: ipPayedCount
            })
            return ipPayedCount;
          }
        }
      }
    },

    async exportVideo() {
      const {data: respData} = await this.$http.get("/api/user/limit?type=draft-work");
      // const draftLimit = respData.data.draft.limit || 0;
      // const draftCount = respData.data.draft.num || 0;
      const worksLimit = respData.data.work.limit || 0;
      const worksCount = respData.data.work.num || 0;
      if (worksLimit && worksCount >= worksLimit) {
        this.$memberGuide({
          show: true,
          context: this,
          funcRight: {
            type: "worksNumber",
            name: "作品数量",
          },
        });
        return;
      }

      await this.getIPRole();
      if (await this.getIPRole()) {
        return;
      }

      this.showExportDialog();
    },
    async showExportDialog() {
      if (this.isRightsRisk()) {
        const cate = this.componyvipMaterial.length ? "企业会员" : "个人会员";
        sensors.track("doratoonGuideePopup", {
          popup_content: "会员素材-导出", // 弹窗引导内容
          restricted_function: "会员素材-导出", // 受限功能
          popup_category1: [cate], // 弹窗分类
        });
        this.$bus.emit("riskDropShow");
        this.editorLoadMore();
        this.riskVisible = true;
        this.$refs.riskDropRef2.setRightsOnly(true);

        // this.ifShowQR();
        return;
      }

      //如果是协同项目，需要判断当前用户是不是项目的创建者
      if (!this.IsPrivateDraft && this.currentDraft && this.currentDraft.shareDraft) {
        if (this.draftOwnerId != this.UserMsg.id) {
          this.$modal.show("MessageDialog", {
            title: "提示",
            content: "您不是该作品的原作者，如需发布为视频请联系作者操作。",
            btns: ["Close"], //["OK", "Cancel","Delete"]
          });
          return;
        }
      }
      this.saveDraftAndJump();
    },
    saveDraftAndJump() {
      this.$store.commit("save_WorksName", this.myWorksName);
      this.$bus.once("saveWorks.completed", () => {
        this.$http
          .get("/api/user/limit?type=work")
          .then((res) => {
            if (res.data.data.exceed) {
              this.$memberGuide({
                show: true,
                context: this,
                funcRight: {
                  type: "worksNumber",
                  name: "作品数量",
                },
              });
            } else {
              const vm = this;
              this.$bus.emit("upDataUserMsg_vue");
              this.$bus.once("upDataUserMsg_vue_done", function hdr() {
                vm.showExportDialog_();
              });
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      });
      this.$bus.emit("topnav.saveWorks", {});
    },
    async showExportDialog_() {
      // UserMsg.type: 0--管理员；1--普通用户；2--外部画师；3--来画画师
      // if (this.UserMsg.levelType == null) {
      //   return;
      // }

      // this.editorLoadMore();

      let timeAll = this.TOOL.getDuration();
      if (this.UserEquity.time && timeAll > this.UserEquity.time) {
        this.$memberGuide({
          show: true,
          context: this,
          funcRight: {
            type: "videoDuration",
            name: "视频时长",
          },
        });

        return;
      }

      if (this.isEmptyEditor()) {
        this.$message({
          message: "您还没有添加任何素材哦，请点击左侧部分添加",
        });
        return;
      }
      // if (!this.IsVipSprites.type) {
      //   this.isShowPopover = true;
      //   return;
      // }

      this.$bus.emit("stop_listen_BGM");
      // this.$bus.emit('showExportVideo');
      this.$bus.emit("FeaturesPop_close_vue", {
        // 关闭弹窗
        type: 3,
      });

      if (this.UserMsg.payForMaterial == 1) {
        let companyResp = await this.$http.get(
          "/api/user/info/applyInfo?type=17"
        );
        let companyResp13 = await this.$http.get(
          "/api/user/info/applyInfo?type=13"
        );
        let data17 = companyResp.data.data || {};
        let data13 = companyResp13.data.data || {};
        this.$store.commit("save_company", {
          name: data17.name || data13.name || "",
          phone: data17.phone || data13.phone || "",
        });
      }

      this.$store.commit("save_TopnavMsg", {
        isShowExportDialog: true,
        isShowSavingMask: true,
        transferData: { type: "" },
        savingMaskText: "正在生成封面数据中...",
      });
    },
    getLoadType() {
      let map = {
        projectId: "draft",
        template: "template",
        storyboard: "story",
      };
      if (this.getUuidInHash().length === 36 && !isBlank) {
        return "draft";
      }
      let arr = Object.keys(map);
      for (let key of arr) {
        if ({}.hasOwnProperty.call(this.$route, key)) {
          return map[key];
        }
      }
      return "blank";
    },
    async getUntitle() {
      return new Promise((resolve, reject) => {
        let untitle;
        this.$http.get("/api/user/draft/untitled").then((res) => {
          let { code, data } = res.data;
          untitle = `未命名-${ pad(++data.count) }`;
          resolve(untitle);
        });
      });

      function pad(num) {
        if (num < 10) {
          return "0" + num;
        }
        return num;
      }
    },
    emitVip() {
      this.$bus.emit("FeaturesPop_vue", {
        name: "vipPayment",
        msg: "请在相应的付款页面进行操作",
        btnClose: "遇到问题",
        btnMsg: "付款成功",
        msgType: 2,
        type: 2,
      });
    },
    setLocationHash() {
      return new Promise((resolve) => {
        this.$http
          .get("/api/user/limit?type=draft")
          .then((res) => {
            let data = res.data.data;
            if (data.num < data.limit) {
              window.location.hash = "/" + uuid.generate();
            } else {
              this.$memberGuide({
                show: true,
                context: this,
                funcRight: {
                  type: "draftNumber",
                  name: "草稿数量",
                },
              });
            }
            resolve();
          })
          .catch((err) => {
            resolve();
            console.warn(err);
          });
      });
    },
    getUuidInHash() {
      return window.location.hash.slice(2) || "";
    },

    /**
     * 检查是否有登录态
     */
    checkLogin() { },

    checkVideoLoad(el) {
      let tid = null;
      return new Promise((resolve, reject) => {
        if (el.preload !== "none") {
          el.addEventListener("canplaythrough", function h() {
            el.removeEventListener("canplaythrough", h);
            clearTimeout(tid);
            resolve();
          });

          tid = setTimeout(() => {
            reject();
          }, 10000);
        } else {
          resolve();
        }
      });
    },
    setLoadingStatus(val = "success") {
      this.TOOL.loading.status = val;
    },
    setAllVideosReady() {
      this.$set(this.TOOL.loading, "allVideosReady", true);
    },
    customerServiceFS(data) {
      switch (data) {
        case "versionUpdate":
          this.$bus.emit("touchGuidance_vue");
          this.$util.localStorage.set("NEW_Version", {
            type: this.UserMsg.versionTOOL,
          });
          this.newVersion = { type: this.UserMsg.versionTOOL };
          break;
        default:
          this.$store.dispatch('showServiceChat');
          break;
      }
    },
    showKeyBindings(el) {
      this.isSettingKeyBindings = true;
      // 显示快捷键弹窗
      this.$bus.emit("FeaturesPop_vue", {
        name: "shortcuts",
        // posx: this.MaterialPane_Size.width + this.Tool_Size.width + this.RightNav_Size.width - 230,
        // posy: this.TopNav_Size.height + this.Tool_Size.height - 250,
        initialX: el.pageX - el.offsetX + 130,
        initialY: el.pageY - el.offsetY - 70,
        type: 1,
      });
    },
    painterFS(data) {
      this.$store.commit("save_TopnavMsg", {
        isShowExportDialog: true,
        isShowSavingMask: true,
        transferData: { type: data, platform: 6 },
        savingMaskText: "正在生成封面数据中...",
      });
    },
    //发布团队模板
    async publishTeamTemplate() {
      // this.$modal.show("MessageDialog", {
      //   title: "提示", //标题
      //   content: "协作编辑模式下，不能发布为团队模板，请至工作台设置发布",
      //   //按钮 （"Ok"，"Delete"，"Cancel"， "Close"为预定义按钮。也可以按格式添加自定义按钮。
      //   //除Close按钮外，其他按钮根据数组顺序排列布局,）
      //   btns: [
      //     "Ok",
      //     "Cancel",
      //     { type: "Refresh", content: "刷新" },
      //     "Delete",
      //     "Close"
      //   ],
      //   //事件处理函数（参数type为按钮的type，值为："Ok"，"Delete"，"Cancel"，"Close","自定义type"）
      //   resultHandler: function(type) {
      //     console.log(type);
      //   }
      // });
      // return;
      if (!this.privateDraft) {
        this.$modal.show("MessageDialog", {
          title: "提示",
          content: "协作编辑模式下，不能发布为团队模板",
          btns: ["Close"], //["OK", "Cancel","Delete"]
        });
        return;
      }

      if (!this.UserTeamInfo || this.UserTeamInfo.type < 0) {
        this.$modal.show("MessageDialog", {
          title: "提示",
          content:
            "您尚未创建团队，并不具备发布团队模板的功能，请创建团队后再尝试。",
          btns: ["Close"], //["OK", "Cancel","Delete"]
        });
        return;
      }
      // (this.UserLevel <= 0 || this.UserMsg.tmpLevelType != null) && !this.UserLevelInfo.trial
      if (this.isPoor) {
        this.$modal.show("MessageDialog", {
          title: "提示",
          content: "添加团队模板为会员功能，如需使用请升级为VIP哦！",
          btns: [{ type: "Cancel", content: "再想想", className: "button-Cancel" }, { type: "Ok", content: "去升级", className: "button-Ok" }],
          resultHandler: (type) => {
            // window.open("vipsolo", "_blank");
            if (type === 'Ok') {
              let link = document.createElement("a");
              link.target = "_blank";
              link.href = "/workplace/pricing/vipsolo";
              link.click();
            }
          },
        });
        return;
      }
      let checkList = [2, 4, 6]; //成员类型，0：普通，2：设计师，4：管理员；6：创作者
      if (
        !this.UserTeamInfo ||
        !checkList.includes(this.UserTeamInfo.type) ||
        this.UserTeamInfo.state > 0
      ) {
        this.$modal.show("MessageDialog", {
          title: "提示",
          content:
            "您不具备将作品发布为团队模板的权限，如需发布请联系管理员或设计师操作。",
          btns: ["Close"], //["OK", "Cancel","Delete"]
        });
        return;
      }

      let _this = this;
      if (this.isLock) {
        this.$bus.emit("saveWorks.completed");
        return;
      }
      this.isLock = true;
      this.unlockDelay();
      this.$store.commit("set_WorksSaveState", "saving");
      //1.上传封面
      let screenParam = await this.uploadThumbnail();
      //2.保存项目
      await this.saveWorks_({ screenParam: screenParam });
      //3.发布团队模板
      if (_this.draftId) {
        this.$http
          .post("/api/user/account/cooperation/template", {
            id: _this.draftId,
            type: 1,
          })
          .then((res) => {
            //console.log(JSON.stringify(res));
            if (res.data.code == 200) {
              this.$message({
                message: "团队模板发布成功，后续可通过工作台协作模块及编辑器团队模块，选择使用",
                type: "success",
                // duration: "1500",
              });
              // this.$modal.show("MessageDialog", {
              //   title: "提示",
              //   content:
              //     "团队模板发布成功，后续可通过工作台协作模块及编辑器团队模块，选择使用",
              //   btns: ["Close"], //["Ok", "Cancel","Delete"]
              // });
            } else {
              this.$modal.show("MessageDialog", {
                title: "提示",
                content: "团队模板发布失败",
                btns: ["Close"], //["Ok", "Cancel","Delete"]
              });
            }
          });
      }
    },
    painterAppFS(data) {
      this.$modal.show("toAppTemplateRemind", data);
      // this.$modal.show("MessageDialog", {
      //   title: "",
      //   content:
      //     "执行导出App模板操作将直接清除两端不兼容的素材，并将不支持的样式以及动画属性重置为对应的默认值。导出模板完成后将直接修改项目的数据，且仅支持发布模板到App平台。请确认！",
      //   btns: ["Cancel", "Ok"], //["OK", "Cancel","Delete"],
      //   resultHandler: type => {
      //     if (type == "Ok") {
      //       this.$store.commit("save_TopnavMsg", {
      //         isShowExportDialog: true,
      //         isShowSavingMask: true,
      //         transferData: { type: "template", platform: 2 },
      //         savingMaskText: "正在生成封面数据中..."
      //       });
      //     }
      //   }
      // });
    },
    updataTemplateFS() {
      if (this.IsVipSprites && this.IsVipSprites.dataLength) {
        this.delVip();
        return;
      }
      this.$store.commit("save_TopnavMsg", {
        isShowExportDialog: true,
        isShowSavingMask: true,
        transferData: {
          type: "updataTemplate",
          id: this.updataTemplatedata.id,
        },
        savingMaskText: "正在生成封面数据中...",
      });
      this.$bus.emit("updataTemplate_emit", this.updataTemplatedata);
    },
    showListDialog() {
      this.$store.commit("save_TopnavMsg", {
        isShowExportSceneList: true,
      });
    },
    //显示购物弹窗
    delVip() {
      console.log('付费清单');
      this.materialPushAnalysisTwo("delVipBtn");
      // this.$bus.emit("Modal_vue", {
      //   name: "delVip",
      //   data: {
      //     type: "record",
      //   },
      // });
    },
    getUnpaidSpritesNum() {
      return $(".delVip").find(".scollBox_page li").length;
    },
    showCustomWorksPopup(ev) {
      // let el = ev.target;
      // let rect = el.getBoundingClientRect();
      // this.$bus.emit('FeaturesPop_vue', {
      //   type: 1,
      //   name: 'customWorks',
      //   initialX: rect.left,
      //   initialY: rect.bottom + 28,
      // });
      // this.$bus.emit('createCustomWorks');
      this.$modal.show("customWorks");
    },
    addEmptyMsg() {
      let $content = this.TOOL.content;
      let h = `
        <div class="__empty-msg">
          <div class="icon"></div>
          <div class="msg">通过左侧栏点击添加一个模板或素材放到这里</div>
          <div class="msg-small">您可以修改模板里的图片、文本信息和颜色</div>
        </div>
      `;
      $content.append(h);
      this.TOOL.handle.data("handler", () => {
        this.MaterialPane_Size.width < 100 &&
          this.$bus.emit("materialPane_vue", {
            type: "template",
          });
      });
      this.TOOL.handle.on("click", this.TOOL.handle.data("handler"));
    },

    openLink(target, isBlank) {
      let link = document.createElement("a");
      link.href = target;
      if (isBlank) {
        link.target = "_blank";
      }
      link.click();
    },
    handleAdvancedUser() {
      let msg = this.$util.localStorage.get("bdVid");
      const userIds = this.$util.localStorage.get("userIds") || [];
      const msgChecked = userIds.indexOf(this.UserMsg.id) > -1;
      if (msg && !msgChecked) {
        msg = JSON.parse(msg.val);
        this.$util.localStorage.set(
          "userIds",
          [].concat(userIds, this.UserMsg.id)
        );
        this.$http.post("/api/common/baiduoCPC", {
          newType: 52,
          url: msg.url,
        });
      }
    },
    async editorLoadMore() {
      let loaded = this.TOOL.sprites.every((v) => v.fromJsonLoadingState >= 1);
      if (loaded) {
        return;
      }
      let sIndex = this.TOOL.sprites.indexOf(this.SelectScenes_Msg);
      //对未加载的场景页进行加载
      this.$bus.emit("loadingAllScenes", "start");
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        const scenes = this.TOOL.sprites[i];
        if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
          await this.TOOL.selectScenes(scenes);
          await scenes.fromJson(
            scenes.unLoadData.json,
            this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
            true
          );
        }
        //初始化一些动画资源
        await scenes.activeAnimation();
      }
      this.TOOL.selectScenes(this.TOOL.sprites[sIndex]);
      this.$bus.emit("loadingAllScenes", "end");
      this.$bus.emit("topnav.editorLoadMore");
      return this.TOOL;
    },
    openHistoryControl({ item } = {}) {
      if (item.type === "version") {
        if (this.cooperationDraftOwnerId) {
          this.openVersionControl();
        }
        // else if (this.UserLevel === 0 && this.UserLevelType === 0) {
        // vip tip

        // this.$modal.show("vipDialog", {
        //   msg: "升级会员，解锁版本记录功能，版本回溯可无忧",
        //   target: "vipsolo",
        //   type: "solo",
        // });
        // }
        else {
          this.openVersionControl();
        }
      }
      if (item.type === "backup") {
        this.openBackupControl();
      }
    },
    openVersionControl() {
      this.$store.commit("draftBackup/isShowUI", false);
      this.$store.commit("versionControl/set_VersionControlShow", true);
    },
    openBackupControl() {
      this.$store.commit("versionControl/set_VersionControlShow", false);
      this.$store.commit("draftBackup/isShowUI", true);
    },
    isCoworker() {
      return (
        this.privateDraft &&
        this.cooperationDraftOwnerId &&
        this.cooperationDraftOwnerId !== this.UserMsg.id
      );
    },
    countdown() {
      clearTimeout(this.backupTimer);
      this.backupTimer = setTimeout(() => {
        this.backup();
      }, this.backupIntervalMinutes * 60000);
    },
    backup() {
      if (this.isPassDraft === 6) {
        return;
      }
      if (this.duringBackup) {
        return;
      }
      this.$store.commit("draftBackup/setDuringBackup", true);
      if (this.backupState === "saved") {
        this.$store.commit("draftBackup/setDuringBackup", false);
        this.countdown();
        return;
      }
      this.saveWorks({ hard: true }).then(async () => {
        await this.createBackup({
          draftId: this.WorksId,
          cooperationDraftId: this.cooperationDraftId,
        });
        this.$store.commit("draftBackup/setDuringBackup", false);
        this.countdown();
      });
    },
    async initBackup() {
      let backupList = await this.fetchBackupList({
        draftId: this.WorksId,
        cooperationDraftId: this.cooperationDraftId,
      });
      if (!backupList || !backupList.length) {
        this.backup();
        return;
      }
      this.countdown();
    },
    hasPayFont() {
      let arr = this.IsVipSprites.data || [];
      return (
        arr.find(
          (v) => v.type === "Text" || v.type === "RichText" || v.fileType == 15
        ) && this.UserMsg.payForFont !== 1
      );
    },
    getCartItemsNum() {
      if (this.UserMsg.payForMaterial == 1) {
        let list = this.IsVipSprites.data || [];
        return (list.filter((v) => v.fileType === 15) || []).length;
      } else {
        return this.IsVipSprites.dataLength;
      }
    },
    storeMultiDraftMark(inputHash) {
      this.onStorageFn = this.onStorageFn || this.onStorage.bind(this);
      let hash = this.getUuidInHash();
      if (inputHash) hash = inputHash;
      if (hash) {
        window.localStorage[hash] = Date.now();
        if (this.onStorageFn) {
          window.removeEventListener("storage", this.onStorageFn);
        }
        window.addEventListener("storage", this.onStorageFn, false);
      }
    },
    onStorage(e) {
      let hashid = this.getUuidInHash();
      if (e.key === hashid) {
        localStorage["_" + hashid] = Date.now();
      }
      if (e.key === "_" + hashid) {
        this.$modal.show("multiDraftMsg");
      }
    },
    async getCooperationAudios(url) {
      let resp = await fetch(this.$handleAssetsUrl(url));
      resp = await resp.json();
      return resp.audios || [];
    },
    checkTrialExpire() {
      // this.trialExpireRiskShown = false;
      if (localStorage.getItem('trialExpireRiskShown')) {
        clearInterval(this.timerOfCheckTrialExpire);
        return;
      }
      const endTime = this.UserMsg.endDay * 1000;
      const danger = 1000 * 60 * 60 * 2;
      const delta = endTime - Date.now();
      if (delta > 0 && delta < danger) {
        this.trialExpireRiskShown = true;
        localStorage.setItem('trialExpireRiskShown', '1');
      } else {
        this.trialExpireRiskShown = false;
      }
    },
    checkTrialExpireRepeatedly() {
      clearInterval(this.timerOfCheckTrialExpire);
      const isPersonTrial = this.UserMsg.tmpLevelType === 0 && this.UserMsg.tmpLevel > 0;
      if (!isPersonTrial) {
        return;
      }
      this.checkTrialExpire();
      this.timerOfCheckTrialExpire = setInterval(() => {
        this.checkTrialExpire();
      }, 60000);
    },
    openPresentationTip() {
      if (!window._firstOpen) {
        const isOpenPresentationTip = localStorage.getItem('isOpenPresentationTip');
        if (!isOpenPresentationTip) {
          // this.$bus.emit('openPresentationTip');
          this.presentationTipShown = true;
          localStorage.setItem('isOpenPresentationTip', '1');
        }
      }
    },
    showPresentation() {
      const presentationGuideShown = localStorage.getItem('editor.presentationGuideShown');
      if (!presentationGuideShown) {
        this.$modal.show('presentationGuide');
        localStorage.setItem('editor.presentationGuideShown', '1');
        return;
      }
      this.$store.commit('previewControls/layerShown', true);
    },
    async getUserExportVedio() {
      const resp = await this.$http.get('/api/user/limit?type=draft-work');
      if(!localStorage.getItem('isInvitated')) {
        localStorage.setItem('isInvitated', 1)
      }
      if (resp.data.data.work.num >= 3 && localStorage.getItem('isInvitated') == 1) {
        this.$store.commit('save_TopnavMsg', {
          isInternaInvitation: true
        });
      localStorage.setItem('isInvitated', 2)
      }
    },
  },
  components: {
    langSelect,
    VipDrop,
    RiskDrop,
    addCooperationDialog,
    historySwitcher,
    qr,
    trialExpireRisk,
    presentationTip,
    AppLogo
  },
};
</script>

<style scoped lang="scss">
.check {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: right;
  align-items: center;
  .el-checkbox {
    margin-right: 8px;
  }
}
.TopNav {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  width: 100%;
  height: 60px;
  background-color: #fff;
  //box-shadow: -4px 0px 4px 0px rgba(44, 75, 248, 0.2);
  border-bottom: 2px solid #daddf7;
  transition: all 0.3s;
  section.left-logo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 164px;
    height: 100%;
    //border-right: 2px solid #daddf7;
    .menu {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 73px;
      height: 60px;
      border-right: 2px solid #daddf7;
      .menu-icon {
        display: inline-block;
        width: 24px;
        height: 27px;
        background: url("../../static/svg/menu.svg") no-repeat center;
        cursor: pointer;
        //margin-left: 20px;
        &:hover {
          background: url("../../static/svg/menu-active.svg") no-repeat center;
        }
      }
    }
    a {
      width: 68px;
      height: 30px;
      margin-left: 13px;
      margin-top: 5px;
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
    }
  }
  section.center-title {
    position: absolute;
    top: 0;
    right: 0;
    left: 164px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    height: 100%;
    padding: 0 0 0 20px;
    // overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    .left-grid {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 180px;
      color: #474261;

      .works-title {
        display: flex;
        align-items: center;
        height: 32px;
        padding-right: 0.8em;
        padding-left: 0.8em;
        background-color: #f2f3f7;
        border-radius: 4px;
        & .icon-title-edit {
          display: none;
          margin-left: 0.8em;
        }
        &:hover {
          background-color: #eaf5fd;
          & .icon-title-edit {
            display: inline-block;
          }
        }
        & > span {
          // margin-right: 0.8em;
          white-space: nowrap;
        }
      }
      .works-title-input {
        width: 182px;
        height: 36px;

        input {
          overflow: hidden;
          width: 100%;
          height: 100%;
          padding: 5px 7px;
          font-size: 14px;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: rgba(243, 243, 247, 1);
          background-color: transparent;
          border: none;
          border: 1px solid transparent;
          border-radius: 4px;
          outline: none;

          &:focus,
          &:hover {
            border-color: #d9ddea;
            cursor: text;
            // box-shadow: 0 0 1px 1px #409eff;
          }
          &:focus {
            border-color: #5778fb;
          }
        }
      }
    }
    .right-grid {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: center;
      flex-grow: 1;
      height: 100%;
      color: #474261;
      color: #474261;
      font-size: 14px;
      * {
        cursor: pointer;
      }

      & > .topnav-btn {
        padding-right: 2px;
        margin-left: 32px;
        font-weight: bold;
        line-height: 34px;

        &.first {
          margin-left: 0;
        }
      }

      .layout {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 0 10px;
        font-size: 14px;
        line-height: 16px;
      }
      .copyrightRisk,
      .copyrightRiskOK,
      .vipUpgrade,
      .addSubtitle,
      // .cooperation,
      .versionHistory,
      .save {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        margin-right: 10px;
        .bg {
          height: 36px;
          border-radius: 4px;
        }
        &:hover {
          .bg {
            background: #fafaff;
          }
        }
      }
      .copyrightRisk {
        .person-learn-text {
          color: #faba40;
        }
        .no-risk-text {
          color: #4bd17a;
        }
        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 10px;
          background-image: url(../../static/svg/topNav/copyrightRisk.svg);
          background-repeat: no-repeat;
        }
        .no-risk .icon {
          background-image: url(../../static/svg/topNav/copyrightRisk-ok.svg);
          &.person-learn {
            background-image: url(../../static/svg/topNav/copyrightRisk-ok-2.svg);
          }
        }
        .copyrightRisk-drop {
          position: absolute;
          top: 100%;
          left: 50%;
          display: none;
          // overflow: hidden;
          // width: 268px;
          // height: 242px;
          // background: #fff;
          // box-shadow: 0 0 4px 0 rgba(54, 76, 204, .4);
          // border-radius: 4px;
          transform: translateX(-50%);
        }
        &:hover {
          .copyrightRisk-drop {
            display: block;
          }
        }
      }
      .copyrightRiskOK {
        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 10px;
          background-image: url(../../static/svg/topNav/copyrightRisk-ok.svg);
          background-repeat: no-repeat;
        }
        & .copyrightOK-drop {
          position: absolute;
          top: 92%;
          left: 50%;
          display: none;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          width: 303px;
          height: 96px;
          padding: 10px;
          color: #fff;
          line-height: 1.8;
          text-align: left;
          background: rgba(0, 0, 0, 0.702);
          box-shadow: 0 0 4px 0 rgba(44, 75, 248, 0.2);
          border-radius: 8px;
          transform: translateX(-50%);
          & > span > span {
            color: #bb9029;
          }
          &:before {
            content: " ";
            position: absolute;
            top: -10px;
            left: 86px;
            border-color: transparent transparent rgba(0, 0, 0, 0.702)
              transparent;
            border-style: solid;
            border-width: 0 6px 10px 6px;
          }
        }
        &:hover {
          .copyrightOK-drop {
            display: flex;
          }
        }
      }
      .vipUpgrade {
        color: #bb9029;
        .icon {
          display: inline-block;
          width: 18px;
          height: 16px;
          margin-right: 10px;
          background-image: url(../../static/svg/topNav/vip.svg);
          background-repeat: no-repeat;
        }
        .vip-drop {
          position: absolute;
          top: 100%;
          left: 50%;
          display: block;
          overflow: hidden;
          width: 312px;
          background: #fff;
          box-shadow: 0 0 4px 0 rgba(54, 76, 204, 0.4);
          border-radius: 4px;
          transform: translateX(-50%);
        }
      }
      .addSubtitle {
        position: relative;
        .icon {
          display: inline-block;
          width: 18px;
          height: 16px;
          margin-right: 10px;
          background-image: url(../../static/svg/topNav/addSubtitle.svg);
          background-repeat: no-repeat;
        }

        &::before {
          content: "NEW";
          position: absolute;
          top: 5px;
          left: 100%;
          width: 36px;
          height: 16px;
          color: #fff;
          font-size: 11px;
          font-weight: bold;
          line-height: 16px;
          background-color: #ff4049;
          border-radius: 10px 5px 10px 0;
          transform: translate(-100%, 0);
        }
      }
      .back-new {
        // height: 36px;
        color: #6464f8;
        font-weight: bold;
        width: 110px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .version-switch-logo-hover {
          display: none;
        }
        &:hover {
          .version-switch-logo-hover {
            display: block;
          }
          .version-switch-logo {
            display: none;
          }
        }
        .version-switch-logo,
        .version-switch-logo-hover {
          height: 36px;
          width: 110px;
          margin-right: 10px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .cooperation {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background-color: #f2f3f7;
        color: #474261;
        border-radius: 4px;
        margin-right: 8px;
        .icon {
          display: inline-block;
          width: 20px;
          height: 14px;
          margin: auto;
          background-image: url(../../static/svg/topNav/cooperation.svg);
          background-repeat: no-repeat;
        }
      }
      .versionHistory {
        margin-right: 10px;
        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 10px;
          background-image: url(../../static/svg/topNav/versionHistory.svg);
          background-repeat: no-repeat;
        }
      }
      .save {
        position: absolute;
        top: 0;
        left: 90px;
        margin-right: 20px;
        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 10px;
          background-image: url(../../static/svg/save.svg);
          background-repeat: no-repeat;
        }
      }

      .presentation-btn {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        margin-right: 8px;
        border-radius: 4px;
        background-color: #f2f3f7;
        color: #474261;
        .badge {
          position: absolute;
          top: -6px;
          right: 8px;
          width: 30px;
          height: 14px;
          background: url(../assets/topNav/badge-new.png) center center/100%
            100% no-repeat;
        }
        .presentation-tip-wrapper {
          position: absolute;
          right: 0;
          top: calc(100% + 11px);
          left: -144px;
          width: 288px;
        }
      }

      .play-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        margin-right: 8px;
        line-height: 32px;
        // background: #fff;
        // border: 1px solid #d9ddea;
        border-radius: 4px;
        background-color: #5778fb;
        color: #ffffff;
        > .iconfont {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          height: 100%;
        }
        &:hover {
          background-color: #f2f3f7;
        }
      }

      .reviewdraft-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100px;
        height: 32px;
        margin-right: 10px;
        color: #474261;
        // line-height: 36px;
        background: #f2f3f7;
        border: 1px solid #f2f3f7;
        border-radius: 4px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        &:hover {
          background-color: #f2f3f7;
        }
      }

      .export-btn {
        position: relative;
        width: 100px;
        height: 32px;
        margin-right: 10px;
        // color: #474261;
        line-height: 32px;
        // background: #fff;
        // border: 1px solid #d9ddea;
        border-radius: 4px;
        &:hover {
          background-color: #7d95f5;
        }
        .btn-name {
          display: flex;
          align-items: center;
          justify-content: center;
          .btn-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 18px;
            height: 18px;
          }
          .tri {
            content: "";
            width: 0;
            height: 0;
            border-color: #fff rgba(0, 0, 0, 0) rgba(0, 0, 0, 0)
              rgba(0, 0, 0, 0);
            border-style: solid;
            border-top-width: 5px;
            border-left-width: 4px;
            border-right-width: 4px;
            margin-top: 2.5px;
          }
        }
        &:hover {
          border-color: #5778fb;
          .export-drop {
            display: block;
          }
        }
        .export-drop {
          position: absolute;
          top: 100%;
          right: 0;
          display: none;
          width: 132px;
          //height: 196px;

          .export-list {
            width: 123px;
            margin-top: 4px;
            color: #474261;
            //height: 192px;
            background: #fff;
            box-shadow: 0 0 4px 0 rgba(54, 76, 204, 0.4);
            border-radius: 4px;
            overflow: hidden;
            padding-top: 4px;
            padding-bottom: 4px;
            margin-right: 0;
            margin-left: auto;
            > div {
              display: flex;
              align-items: center;
              width: 100%;
              height: 36px;
              padding-left: 14px;
              padding-right: 14px;

              &:hover {
                background-color: #f0f0f8;
                cursor: pointer;
              }
            }
            .disabled {
              cursor: default;
              pointer-events: none;
            }
          }
        }
        .expire-risk-wrapper {
          position: absolute;
          right: 0;
          top: calc(100% + 8px);
          width: 392px;
        }
      }

      .customerService {
        position: relative;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 35px;
        height: 22px;
        line-height: 25px;
      }
      .colorPointRed,
      .colorPointYellow {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: -3px;
          right: -3px;
          width: 8px;
          height: 8px;
          background: #ffc300;
          border-radius: 100%;
        }
      }
      .colorPointRed {
        &:before {
          top: -5px;
          right: -8px;
          background: #ffc300;
        }
      }
      .customerServiceCil {
        &:hover {
          .helpList {
            height: 247px;
            padding-top: 40px;
            color: #474261;
            opacity: 1;

            .helpbody {
              &:before {
                top: 33px;
              }
            }
          }
        }
      }
      .spriteVipList {
        position: relative;
        width: 128px;
        height: 30px;
        color: #5778fb;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-stretch: normal;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0;
        // background-image: linear-gradient(108deg,
        //   #36332f 0%,
        //   #12100a 100%);
        // box-shadow: 0px 0px 4px 0px
        //   rgba(44, 75, 248, 0.2);
        background-color: #fff;
        border: solid 1px #5778fb;
        border-radius: 15px;
        transition: all 0.3s;

        & > .badge {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          color: #fff;
          background-color: red;
          border: 1px #fff solid;
          border-radius: 50%;
          transform: translate(50%, -50%) scale(0.8);
        }

        &:hover {
          opacity: 0.8;
        }

        > img {
          width: 18px;
          vertical-align: sub;
        }
      }
    }
  }
}

.btn-linear-gradient {
  width: 88px;
  height: 30px;
  color: #fff;
  // background-image: linear-gradient(
  //   128deg,
  //   #692eff 0%,
  //   #599bff 32%,
  //   #325bff 100%
  // );
  background-image: linear-gradient(128deg, #15a7e4 0%, #7f32ff 100%);
  box-shadow: 0 0 4px 0 rgba(44, 75, 248, 0.2);
  border-radius: 15px;
  &:hover {
    opacity: 0.8;
  }
}

.template-game-badge {
  display: inline-block;
  padding: 2px 4px;
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  background-color: #f458d4;
  border-radius: 5px;
  &.ghost {
    opacity: 0;
  }
}

.history-switcher-wrapper {
  position: absolute;
  top: 0;
  left: 20px;
  display: flex;
  align-items: center;
  height: 100%;
}

.create-presentation-link {
  position: relative;
  .badge {
    position: absolute;
    top: -2px;
    right: 14px;
    width: 30px;
    height: 14px;
    background: url(../assets/topNav/badge-new.png) center center/100% 100%
      no-repeat;
  }
}
</style>
<style scoped lang="scss">
#editor > .hide {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue